'use client'
import {
  LENGTH_8_PATTERN,
  ONE_LETTER_PATTERN,
  ONE_NUMBER_PATTERN
} from "./chunk-V6OLRYZ6.mjs";
import {
  getDefaultUser
} from "./chunk-OJQ5OICL.mjs";
import {
  MIN_AGE_ALLOWED
} from "./chunk-F4OYSSS5.mjs";
import {
  COOKIE_REFRESH_TOKEN,
  COOKIE_TOKEN,
  COOKIE_TOKEN_EXPIRES_IN
} from "./chunk-5KF4VIOG.mjs";
import {
  context_default,
  useAuth
} from "./chunk-ZF2ENNTR.mjs";
import {
  useEmailSpelling
} from "./chunk-X3QLCDDI.mjs";
import {
  __async,
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/components/checkpoint/global/index.tsx
import { useEffect as useEffect6, useRef as useRef2, useState as useState3 } from "react";
import { Button as Button12, ResponsiveModal as ResponsiveModal2, Typography as Typography4 } from "@wbk/ui";
import { FormProvider as FormProvider3, useForm as useForm3 } from "react-hook-form";
import { AnimatePresence as AnimatePresence5, motion as motion5 } from "motion/react";
import { useRouter as useRouter15, useTranslation as useTranslation20 } from "@wbk/config";
import { ExclamationTriangleIcon } from "@wbk/svg";
import { useAnalytics as useAnalytics9 } from "@wbk/analytics";

// src/context/provider.tsx
import { useEffect as useEffect4, useMemo as useMemo5, useState as useState2 } from "react";
import { ApiConfig, refreshTokens } from "@wbk/api";
import { useGetUser } from "@wbk/api/hooks";
import { createCookie, eraseCookie, loadScriptAsync, readCookie } from "@wbk/utils";
import { useAnalytics as useAnalytics8 } from "@wbk/analytics";
import { useRouter as useRouter13 } from "@wbk/config";

// src/components/form/Form.tsx
import { useEffect as useEffect2, useMemo as useMemo2 } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { AnimatePresence as AnimatePresence4, motion as motion4 } from "motion/react";
import { WithGrecaptcha } from "@wbk/api/grecaptcha";
import { twMerge as twMerge2 } from "tailwind-merge";
import { useGeolocation, useRouter as useRouter6, useTranslation as useTranslation9 } from "@wbk/config";
import { useAnalytics as useAnalytics5 } from "@wbk/analytics";

// src/components/button/Back.tsx
import { twMerge } from "tailwind-merge";
import { Button } from "@wbk/ui";
import { useTranslation } from "@wbk/config";
import { jsx, jsxs } from "react/jsx-runtime";
var BackButton = (_a) => {
  var _b = _a, { text, className = "" } = _b, props = __objRest(_b, ["text", "className"]);
  const { t } = useTranslation(["auth_common"]);
  return /* @__PURE__ */ jsxs(
    Button,
    __spreadProps(__spreadValues({
      theme: "transparent",
      shape: "text",
      className: twMerge(
        "hover:bg-primary/10 -mx-1 mb-2 flex min-h-[30px] min-w-[36px] shrink-0 items-center gap-2 !px-1 py-1 text-sm hover:opacity-60 focus:ring-1",
        className
      )
    }, props), {
      children: [
        /* @__PURE__ */ jsx(
          "svg",
          {
            className: "h-6 w-6 shrink-0 ltr:rotate-180",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /* @__PURE__ */ jsx(
              "path",
              {
                d: "M8.58984 16.59L13.1698 12L8.58984 7.41L9.99984 6L15.9998 12L9.99984 18L8.58984 16.59Z",
                fill: "currentColor"
              }
            )
          }
        ),
        /* @__PURE__ */ jsx("span", { className: "ltr:pr-2 rtl:pl-2", children: text || t("auth_common:back") })
      ]
    })
  );
};
var Back_default = BackButton;

// src/components/form/Login.tsx
import { useEffect } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { AnimatePresence, motion } from "motion/react";
import { useAnalytics } from "@wbk/analytics";
import { Button as Button2, Input } from "@wbk/ui";
import { useForgotPassword, useLogin } from "@wbk/api/hooks";
import { EMAIL_PATTERN } from "@wbk/utils";
import { setLoggerUser } from "@wbk/logger";
import { WbkLogo } from "@wbk/svg";
import { useAppSource, useRouter, useTranslation as useTranslation2 } from "@wbk/config";
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var EmailLogin = ({ onSuccess }) => {
  const {
    watch,
    control,
    formState: { errors },
    handleSubmit,
    getValues,
    setValue
  } = useFormContext();
  const { setTokens, poweredBy } = useAuth();
  const { appSource } = useAppSource();
  const { locale, search } = useRouter();
  const { t } = useTranslation2(["auth_common"]);
  const { mutateAsync: login, isPending, error: loginError } = useLogin({ lang: locale });
  const {
    mutateAsync: forgotPassword,
    isPending: passLoading,
    error: passError
  } = useForgotPassword();
  const { loginEvent, trackEvent } = useAnalytics();
  const mode = watch("mode");
  const isLoading = isPending || passLoading;
  const error = (loginError == null ? void 0 : loginError.message) || (passError == null ? void 0 : passError.message);
  const onSubmit = (data) => __async(void 0, null, function* () {
    var _a, _b, _c, _d, _e;
    try {
      const email = ((_a = data == null ? void 0 : data.email) == null ? void 0 : _a.trim()) || "";
      const body = { email, locale, app_source: appSource };
      if (mode === "reset-email") {
        yield forgotPassword(body);
        setValue("mode", "reset-otp");
        trackEvent({
          event: "Reset Password - Send OTP Success",
          data: { email: getValues("email") }
        });
      } else {
        const res = yield login(__spreadProps(__spreadValues({}, body), { password: data.password }));
        setTokens({
          accessToken: (_b = res == null ? void 0 : res.user) == null ? void 0 : _b.access_token,
          refreshToken: (_c = res == null ? void 0 : res.user) == null ? void 0 : _c.refresh_token,
          tokenExpiresIn: (_d = res == null ? void 0 : res.user) == null ? void 0 : _d.token_expires_in
        });
        if ((_e = res == null ? void 0 : res.user) == null ? void 0 : _e.force_verify_email) {
          yield forgotPassword(__spreadProps(__spreadValues({}, body), { checkout_verify: true }));
          setValue("mode", "otp");
          return;
        }
        if (onSuccess) {
          onSuccess(res.user);
        }
        loginEvent({
          method: "email",
          user: __spreadProps(__spreadValues({}, res.user), { locale })
        });
        setLoggerUser(res.user);
      }
    } catch (error2) {
      if (mode === "email") {
        trackEvent({ event: "Login - Login Failed", data: { email: data.email, error: error2 } });
      }
    }
  });
  useEffect(() => {
    var _a, _b;
    if (typeof window === "undefined")
      return;
    const token = (_a = search.get("token")) != null ? _a : "";
    if (token) {
      setTokens({ accessToken: token });
    }
    const encodedEmail = (_b = search.get("email")) != null ? _b : "";
    const email = decodeURIComponent(encodedEmail);
    const isValidEmail = EMAIL_PATTERN.test(email);
    if (email && isValidEmail) {
      setValue("email", email);
    }
  }, []);
  return /* @__PURE__ */ jsxs2("form", { onSubmit: handleSubmit(onSubmit), id: "email-login", name: "email-login-form", children: [
    poweredBy && /* @__PURE__ */ jsxs2("div", { className: "text-secondary-contrast pb-4 text-center", children: [
      /* @__PURE__ */ jsxs2("div", { className: "flex items-center justify-center gap-3", children: [
        /* @__PURE__ */ jsx2("p", { className: "text-xs", children: t("auth_common:powered") }),
        /* @__PURE__ */ jsx2(WbkLogo, { width: 45, height: 14, className: "text-[#F84878]" })
      ] }),
      /* @__PURE__ */ jsx2("p", { className: "text-sm", children: t("auth_common:wbk_login") })
    ] }),
    /* @__PURE__ */ jsx2(
      Controller,
      {
        control,
        name: "email",
        rules: {
          required: t("auth_common:validation.required"),
          pattern: {
            value: EMAIL_PATTERN,
            message: t("auth_common:validation.invalid_email")
          }
        },
        defaultValue: "",
        render: (_a) => {
          var { field: _b } = _a, _c = _b, { onChange } = _c, props = __objRest(_c, ["onChange"]);
          var _a2;
          return /* @__PURE__ */ jsx2(
            Input,
            __spreadProps(__spreadValues({}, props), {
              "data-testid": mode === "reset-email" ? "auth_reset_password_email_input" : "auth_login_email_input",
              type: "email",
              label: /* @__PURE__ */ jsx2("span", { className: "font-semibold", children: t("auth_common:email") }),
              placeholder: "you@email.com",
              onChange: (value) => {
                onChange(value);
              },
              error: (_a2 = errors.email) == null ? void 0 : _a2.message
            })
          );
        }
      }
    ),
    /* @__PURE__ */ jsx2("div", { className: "h-4" }),
    /* @__PURE__ */ jsx2(AnimatePresence, { initial: false, children: mode !== "reset-email" && /* @__PURE__ */ jsxs2(
      motion.div,
      {
        className: "overflow-hidden",
        initial: { height: 0 },
        animate: { height: "auto" },
        exit: { height: 0 },
        children: [
          /* @__PURE__ */ jsx2(
            Controller,
            {
              control,
              name: "password",
              rules: {
                required: t("auth_common:validation.required")
              },
              defaultValue: "",
              render: (_d) => {
                var { field: _e } = _d, _f = _e, { onChange } = _f, props = __objRest(_f, ["onChange"]);
                var _a;
                return /* @__PURE__ */ jsx2(
                  Input,
                  __spreadProps(__spreadValues({}, props), {
                    id: "password",
                    "data-testid": "auth_login_password_input",
                    type: "password",
                    label: t("auth_common:password"),
                    onChange: (value) => {
                      onChange(value);
                    },
                    error: (_a = errors.password) == null ? void 0 : _a.message,
                    hideErrorSpace: true
                  })
                );
              }
            },
            "login-password"
          ),
          /* @__PURE__ */ jsx2("div", { className: "flex justify-end text-sm", children: /* @__PURE__ */ jsx2(
            Button2,
            {
              className: "hover:!text-primary my-4 flex justify-end !p-0.5 !text-blue-500 underline-offset-2 !ring-0 hover:underline",
              theme: "transparent",
              shape: "text",
              type: "button",
              "data-testid": "auth_reset_password",
              onClick: () => {
                setValue("password", "");
                setValue("mode", "reset-email");
                trackEvent({ event: "Reset Password - Page View" });
              },
              children: t("auth_common:reset_password_question")
            }
          ) })
        ]
      }
    ) }),
    /* @__PURE__ */ jsx2("div", { className: "text-center", id: "v2-captcha-section" }),
    !!error && /* @__PURE__ */ jsx2("p", { className: "text-error pb-2 text-center text-sm", children: error }),
    /* @__PURE__ */ jsx2(
      Button2,
      {
        type: "submit",
        form: "email-login",
        className: "mt-4 w-full",
        onClick: () => {
          if (mode === "reset-email") {
            return trackEvent({
              event: "Reset Password - Send OTP Btn",
              data: { email: getValues("email") }
            });
          }
          trackEvent({ event: "Login - Login Btn", data: { email: getValues("email") } });
        },
        loading: isLoading,
        id: "email-login-button",
        "data-testid": mode === "reset-email" ? "auth_send_reset_password_code_button" : "auth_login_submit_button",
        shape: "solid",
        children: /* @__PURE__ */ jsx2("span", { className: "text-xl font-bold", children: mode === "reset-email" ? t("auth_common:send_otp") : t("auth_common:login") })
      }
    ),
    /* @__PURE__ */ jsx2(AnimatePresence, { initial: false, children: mode !== "reset-email" && /* @__PURE__ */ jsxs2(
      motion.div,
      {
        className: "overflow-hidden text-center",
        initial: { height: 0 },
        animate: { height: "auto" },
        exit: { height: 0 },
        children: [
          /* @__PURE__ */ jsx2("hr", { className: "border-body-level-2 mb-4 mt-6" }),
          /* @__PURE__ */ jsx2("p", { className: "text-sm", children: t("auth_common:dont_have_account") }),
          /* @__PURE__ */ jsx2(
            Button2,
            {
              className: "mt-3 w-full max-w-[200px] !py-1",
              theme: "white",
              shape: "outlined",
              "data-testid": "auth_signup_button",
              type: "button",
              onClick: () => {
                setValue("mode", "signup");
                trackEvent({ event: "Signup - Page View" });
              },
              children: t("auth_common:signup")
            }
          )
        ]
      }
    ) })
  ] });
};
var Login_default = EmailLogin;

// src/components/form/OtpSignup.tsx
import { useFormContext as useFormContext2 } from "react-hook-form";
import { Button as Button3, OtpInputs } from "@wbk/ui";
import { useForgotPassword as useForgotPassword2, useResendOtp, useVerifyOtp } from "@wbk/api/hooks";
import { useAppSource as useAppSource2, useRouter as useRouter2, useTranslation as useTranslation3 } from "@wbk/config";
import { useAnalytics as useAnalytics2 } from "@wbk/analytics";

// src/components/countdown/WithCountDown.tsx
import { useCountDown } from "@wbk/hooks";
var WithCountDown = ({ render, seconds }) => {
  const { count, reset, set } = useCountDown({ id: "withcount-down", initialSeconds: seconds });
  return render({ count, reset, set });
};
var WithCountDown_default = WithCountDown;

// src/components/form/OtpSignup.tsx
import { jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
var OtpSignup = () => {
  const { getValues, setValue, watch } = useFormContext2();
  const { setTokens } = useAuth();
  const { appSource } = useAppSource2();
  const { locale } = useRouter2();
  const { trackEvent } = useAnalytics2();
  const { mutateAsync: verifyOtp, isPending, error: otpError } = useVerifyOtp({ lang: locale });
  const {
    mutateAsync: forgotPassword,
    isPending: passLoading,
    error: passError
  } = useForgotPassword2();
  const { mutateAsync: resendOtp, isPending: resendLoading, error: resendError } = useResendOtp();
  const isLoading = isPending || passLoading || resendLoading;
  const error = (otpError == null ? void 0 : otpError.message) || (passError == null ? void 0 : passError.message) || (resendError == null ? void 0 : resendError.message);
  const { t } = useTranslation3(["auth_common"]);
  const otp = watch("otp");
  const mode = watch("mode");
  const handleOtp = (otp2) => __async(void 0, null, function* () {
    try {
      const body = {
        email: getValues("email"),
        otp: otp2,
        locale
      };
      if (mode === "reset-otp") {
        yield verifyOtp(__spreadProps(__spreadValues({}, body), { verify_otp: true }));
        setValue("mode", "reset-password");
      } else {
        const data = yield verifyOtp(__spreadProps(__spreadValues({}, body), { otp: otp2 }));
        if (data == null ? void 0 : data.user) {
          const user = __spreadProps(__spreadValues({}, data.user), {
            new_user: data.new_user || false
          });
          setTokens({
            accessToken: user.access_token,
            refreshToken: user.refresh_token,
            tokenExpiresIn: user.token_expires_in
          });
        }
        trackEvent({
          event: "Reset Password - Verify OTP Success",
          data: { email: getValues("email") }
        });
      }
    } catch (error2) {
      if (mode === "reset-otp") {
        trackEvent({
          event: "Reset Password - Verify OTP Failed",
          data: { email: getValues("email"), error: error2 }
        });
      }
    }
  });
  const resendCode = () => __async(void 0, null, function* () {
    try {
      const body = {
        email: getValues("email"),
        resend: true,
        locale,
        app_source: appSource
      };
      if (mode === "reset-otp") {
        yield forgotPassword(body);
      } else {
        yield resendOtp(body);
        trackEvent({
          event: "Reset Password - Resend OTP",
          data: { email: body.email }
        });
      }
    } catch (err) {
    }
  });
  return /* @__PURE__ */ jsxs3("div", { className: "", children: [
    /* @__PURE__ */ jsx3("div", { className: "text-center text-2xl font-bold", children: t("auth_common:verify_your_email_address") }),
    /* @__PURE__ */ jsx3(
      OtpInputs,
      {
        formId: "otp-verify",
        legend: /* @__PURE__ */ jsx3("p", { className: "px-2 py-4 text-center text-sm text-zinc-500", children: t("auth_common:enter_the_otp", { email: getValues("email") }) }),
        onChange: (v) => {
          setValue("otp", v);
        },
        onSubmit: handleOtp,
        onlyNumbers: true,
        disabled: isLoading,
        error,
        renderButton: ({ resetState }) => /* @__PURE__ */ jsxs3("div", { className: "mt-6 text-center text-sm", children: [
          /* @__PURE__ */ jsx3(
            WithCountDown_default,
            {
              seconds: 60,
              render: ({ count, reset }) => /* @__PURE__ */ jsxs3("div", { className: "flex items-center justify-center gap-2", children: [
                /* @__PURE__ */ jsx3("p", { className: "mx-1 font-medium text-zinc-500", children: t("auth_common:didnt_receive_it") }),
                /* @__PURE__ */ jsx3(
                  Button3,
                  {
                    type: "button",
                    "data-testid": "auth_otp_resend_code_button",
                    shape: "text",
                    className: "px-2 py-1 text-sm",
                    disabled: count > 0,
                    loading: isLoading,
                    onClick: () => __async(void 0, null, function* () {
                      try {
                        yield resendCode();
                        reset();
                        resetState();
                      } catch (error2) {
                      }
                    }),
                    id: "resend-otp",
                    children: `${t("auth_common:resend_otp")} ${count > 0 ? `(${count})` : ""}`
                  }
                )
              ] })
            }
          ),
          /* @__PURE__ */ jsx3("div", { className: "p-4", children: /* @__PURE__ */ jsx3(
            Button3,
            {
              type: "submit",
              form: "otp-verify",
              "data-testid": "auth_reset_password_otp_submit",
              disabled: (otp == null ? void 0 : otp.length) !== 4,
              loading: isLoading,
              className: "mt-6 w-full",
              id: "verify-otp",
              children: /* @__PURE__ */ jsx3("span", { className: "text-xl font-bold", children: mode === "reset-otp" ? t("auth_common:reset_password") : t("auth_common:verify") })
            }
          ) })
        ] })
      }
    )
  ] });
};
var OtpSignup_default = OtpSignup;

// src/components/form/NewPasswordForm.tsx
import { Controller as Controller2, useFormContext as useFormContext3 } from "react-hook-form";
import { AnimatePresence as AnimatePresence2, motion as motion2 } from "motion/react";
import { Button as Button4, Input as Input2 } from "@wbk/ui";
import { useChangePassword } from "@wbk/api/hooks";
import { useRouter as useRouter3, useTranslation as useTranslation5 } from "@wbk/config";
import { useAnalytics as useAnalytics3 } from "@wbk/analytics";

// src/components/bullets/PasswordBullets.tsx
import { CheckIcon, CloseIcon } from "@wbk/svg";
import { useTranslation as useTranslation4 } from "@wbk/config";
import { jsx as jsx4, jsxs as jsxs4 } from "react/jsx-runtime";
var PasswordBullets = ({ password = "", error }) => {
  const { t } = useTranslation4(["auth_common"]);
  const lengthValid = LENGTH_8_PATTERN.test(password);
  const oneLetterValid = ONE_LETTER_PATTERN.test(password);
  const oneNumberValid = ONE_NUMBER_PATTERN.test(password);
  const isValid = lengthValid && oneLetterValid && oneNumberValid;
  return /* @__PURE__ */ jsx4("ul", { className: "mb-4 space-y-1 text-sm", children: /* @__PURE__ */ jsxs4(
    "li",
    {
      className: `flex items-start gap-1 ${isValid ? "text-primary-success" : error ? "text-primary-red" : ""}`,
      children: [
        isValid ? /* @__PURE__ */ jsx4(CheckIcon, { className: "[&>path]:fill-body mt-0.5 h-5 w-8 text-green-500" }) : /* @__PURE__ */ jsx4(CloseIcon, { className: "mt-0.5 h-5 w-8 rounded-full text-red-500" }),
        /* @__PURE__ */ jsx4("span", { children: t("auth_common:validation.password_validation") })
      ]
    }
  ) });
};
var PasswordBullets_default = PasswordBullets;

// src/components/form/NewPasswordForm.tsx
import { jsx as jsx5, jsxs as jsxs5 } from "react/jsx-runtime";
var NewPasswordForm = () => {
  var _d, _e, _i, _j, _k;
  const {
    setValue,
    control,
    handleSubmit,
    formState: { errors, isValid },
    watch,
    getFieldState
  } = useFormContext3();
  const { mutateAsync: changePassword, isPending, error } = useChangePassword();
  const { locale } = useRouter3();
  const { trackEvent } = useAnalytics3();
  const { t } = useTranslation5(["auth_common"]);
  const password = watch("new_password");
  const passwordState = getFieldState("new_password");
  const onSubmit = (props) => __async(void 0, null, function* () {
    try {
      yield changePassword({
        email: props.email,
        new_password: props.new_password || "",
        re_enter_password: props.confirm_password || "",
        verification_code: props.otp || "",
        lang: locale
      });
      setValue("mode", "reset-password-success");
      trackEvent({
        event: "Reset Password - Reset Password Success",
        data: { email: props.email }
      });
    } catch (error2) {
      trackEvent({
        event: "Reset Password - Reset Password Failed",
        data: { email: props.email, error: error2 }
      });
    }
  });
  return /* @__PURE__ */ jsxs5("form", { id: "reset-password-form", onSubmit: handleSubmit(onSubmit), children: [
    /* @__PURE__ */ jsx5(
      Controller2,
      {
        control,
        name: "new_password",
        rules: {
          required: t("auth_common:validation.required"),
          validate: (value) => {
            const val = value || "";
            const lengthValid = LENGTH_8_PATTERN.test(val);
            const oneLetterValid = ONE_LETTER_PATTERN.test(val);
            const oneNumberValid = ONE_NUMBER_PATTERN.test(val);
            const isValid2 = lengthValid && oneLetterValid && oneNumberValid;
            return isValid2;
          }
        },
        defaultValue: "",
        render: (_a) => {
          var { field: _b } = _a, _c = _b, { onChange } = _c, props = __objRest(_c, ["onChange"]);
          var _a2, _b2, _c2;
          return /* @__PURE__ */ jsx5(
            Input2,
            __spreadProps(__spreadValues({}, props), {
              type: "password",
              "data-testid": "auth_new_password_input",
              label: t("auth_common:new_password"),
              onChange: (value) => {
                onChange(value);
              },
              error: ((_a2 = errors.new_password) == null ? void 0 : _a2.message) || !!((_c2 = (_b2 = error == null ? void 0 : error.errors) == null ? void 0 : _b2.new_password) == null ? void 0 : _c2.length)
            })
          );
        }
      }
    ),
    !!((_e = (_d = error == null ? void 0 : error.errors) == null ? void 0 : _d.new_password) == null ? void 0 : _e.length) && /* @__PURE__ */ jsx5("div", { className: "space-y-1 pt-1", children: error.errors.new_password.map((err) => /* @__PURE__ */ jsx5("p", { className: "text-error text-sm", children: err }, err)) }),
    /* @__PURE__ */ jsx5("div", { className: "mt-2", children: /* @__PURE__ */ jsx5(PasswordBullets_default, { password: password || "" }) }),
    /* @__PURE__ */ jsx5(AnimatePresence2, { children: passwordState.isDirty && !passwordState.invalid && /* @__PURE__ */ jsxs5(
      motion2.div,
      {
        className: "overflow-hidden",
        initial: { height: 0 },
        animate: { height: "auto" },
        exit: { height: 0 },
        children: [
          /* @__PURE__ */ jsx5(
            Controller2,
            {
              control,
              name: "confirm_password",
              rules: {
                required: t("auth_common:validation.required"),
                validate: (value) => value === password || t("auth_common:validation.passwords_not_match")
              },
              defaultValue: "",
              render: (_f) => {
                var { field: _g } = _f, _h = _g, { onChange } = _h, props = __objRest(_h, ["onChange"]);
                var _a, _b, _c;
                return /* @__PURE__ */ jsx5(
                  Input2,
                  __spreadProps(__spreadValues({}, props), {
                    autoComplete: "off",
                    type: "password",
                    "data-testid": "auth_confirm_new_password_input",
                    label: t("auth_common:confirm_password"),
                    onChange: (value) => {
                      onChange(value);
                    },
                    onPaste: (e) => {
                      e.preventDefault();
                    },
                    error: ((_a = errors.confirm_password) == null ? void 0 : _a.message) || !!((_c = (_b = error == null ? void 0 : error.errors) == null ? void 0 : _b.re_enter_password) == null ? void 0 : _c.length)
                  })
                );
              }
            }
          ),
          !!((_j = (_i = error == null ? void 0 : error.errors) == null ? void 0 : _i.re_enter_password) == null ? void 0 : _j.length) && /* @__PURE__ */ jsx5("div", { className: "space-y-1 pt-1", children: (_k = error == null ? void 0 : error.errors) == null ? void 0 : _k.re_enter_password.map((err) => /* @__PURE__ */ jsx5("p", { className: "text-error text-sm", children: err }, err)) })
        ]
      }
    ) }),
    typeof (error == null ? void 0 : error.message) === "string" && error.message !== "[object Object]" && /* @__PURE__ */ jsx5("p", { className: "text-error pt-1 text-center text-sm", children: error.message }),
    /* @__PURE__ */ jsx5(
      Button4,
      {
        type: "submit",
        form: "reset-password-form",
        className: "mt-4 w-full",
        loading: isPending,
        disabled: !isValid,
        id: "reset-password-form-button",
        "data-testid": "auth_update_password_button",
        children: /* @__PURE__ */ jsx5("span", { className: "text-xl font-bold", children: t("auth_common:update_password") })
      }
    )
  ] });
};
var NewPasswordForm_default = NewPasswordForm;

// src/components/form/ResetPasswordSuccess.tsx
import { useFormContext as useFormContext4 } from "react-hook-form";
import { Button as Button5 } from "@wbk/ui";
import { AnimatedCheck } from "@wbk/svg";
import { useTranslation as useTranslation6 } from "@wbk/config";
import { jsx as jsx6, jsxs as jsxs6 } from "react/jsx-runtime";
var ResetPasswordSuccess = () => {
  const { setValue } = useFormContext4();
  const { t } = useTranslation6(["auth_common"]);
  return /* @__PURE__ */ jsxs6("div", { className: "text-center", children: [
    /* @__PURE__ */ jsx6(AnimatedCheck, { className: "text-success mx-auto h-60 w-60" }),
    /* @__PURE__ */ jsx6("h2", { className: "pb-1", children: t("auth_common:password_updated") }),
    /* @__PURE__ */ jsx6(
      Button5,
      {
        "data-testid": "auth_to_login_after_reset_button",
        className: "mt-8 w-full",
        onClick: () => {
          setValue("mode", "email");
        },
        children: /* @__PURE__ */ jsx6("span", { className: "text-xl font-bold", children: t("auth_common:login") })
      }
    )
  ] });
};
var ResetPasswordSuccess_default = ResetPasswordSuccess;

// src/components/form/Signup.tsx
import { useMemo } from "react";
import { Controller as Controller4, useFormContext as useFormContext6 } from "react-hook-form";
import { AnimatePresence as AnimatePresence3, motion as motion3 } from "motion/react";
import { useAnalytics as useAnalytics4 } from "@wbk/analytics";
import { Button as Button6, Checkbox } from "@wbk/ui";
import { Exception, setLoggerUser as setLoggerUser2 } from "@wbk/logger";
import { useRegister } from "@wbk/api/hooks";
import { getItem } from "@wbk/utils";
import { Link, Trans, useRouter as useRouter5, useTranslation as useTranslation8 } from "@wbk/config";

// src/components/form/SignupFormData.tsx
import { Controller as Controller3, useFormContext as useFormContext5 } from "react-hook-form";
import { Input as Input3, MobileInput } from "@wbk/ui";
import { SinglePerson } from "@wbk/svg";
import { useRouter as useRouter4, useTranslation as useTranslation7 } from "@wbk/config";
import { jsx as jsx7, jsxs as jsxs7 } from "react/jsx-runtime";
var SignupFormData = ({ onSubmit }) => {
  var _j, _k, _l;
  const { locale } = useRouter4();
  const {
    control,
    setValue,
    handleSubmit,
    formState: { errors },
    watch
  } = useFormContext5();
  const { t } = useTranslation7("auth_common");
  const email = watch("email");
  const password = watch("password");
  const selectedCountry = watch("selected_country");
  const error = watch("error");
  const emailSuggestion = useEmailSpelling({ email });
  return /* @__PURE__ */ jsxs7("form", { id: "signup-form-info", className: "space-y-4", onSubmit: handleSubmit(onSubmit), noValidate: true, children: [
    /* @__PURE__ */ jsxs7("div", { className: "mt-1 flex flex-col-reverse items-center justify-between gap-4 sm:flex-row", children: [
      /* @__PURE__ */ jsxs7("div", { className: "grow space-y-2", children: [
        /* @__PURE__ */ jsx7("h4", { className: "text-2xl", children: t("auth_common:welcome") }),
        /* @__PURE__ */ jsx7("p", { className: "text-text-secondary text-sm", children: t("auth_common:welcome_text") })
      ] }),
      /* @__PURE__ */ jsx7("div", { className: "bg-body-dark/10 text-body-level-2 flex h-16 w-16 max-w-[100px] shrink-0 items-center justify-center rounded-full sm:max-w-none", children: /* @__PURE__ */ jsx7(SinglePerson, { className: "h-10 w-10" }) })
    ] }),
    /* @__PURE__ */ jsxs7("fieldset", { className: "flex flex-col gap-2 py-1 sm:flex-row", children: [
      /* @__PURE__ */ jsx7("div", { className: "grow", children: /* @__PURE__ */ jsx7(
        Controller3,
        {
          control,
          name: "first_name",
          rules: {
            required: t("auth_common:validation.required"),
            maxLength: {
              value: 25,
              message: t("auth_common:validation.max_length", { max: 25 })
            }
          },
          defaultValue: "",
          render: (_a) => {
            var { field: _b } = _a, _c = _b, { onChange } = _c, props = __objRest(_c, ["onChange"]);
            var _a2, _b2, _c2;
            return /* @__PURE__ */ jsx7(
              Input3,
              __spreadProps(__spreadValues({
                id: "first_name",
                "data-testid": "auth_firstname_input",
                autoComplete: "off",
                label: t("auth_common:first_name")
              }, props), {
                onChange: (value) => {
                  onChange(value);
                },
                error: ((_a2 = errors.first_name) == null ? void 0 : _a2.message) || ((_c2 = (_b2 = error == null ? void 0 : error.errors) == null ? void 0 : _b2.first_name) == null ? void 0 : _c2[0])
              })
            );
          }
        }
      ) }),
      /* @__PURE__ */ jsx7("div", { className: "grow", children: /* @__PURE__ */ jsx7(
        Controller3,
        {
          control,
          name: "last_name",
          rules: {
            required: t("auth_common:validation.required"),
            maxLength: {
              value: 25,
              message: t("auth_common:validation.max_length", { max: 25 })
            }
          },
          defaultValue: "",
          render: (_d) => {
            var { field: _e } = _d, _f = _e, { onChange } = _f, props = __objRest(_f, ["onChange"]);
            var _a, _b, _c;
            return /* @__PURE__ */ jsx7(
              Input3,
              __spreadProps(__spreadValues({
                id: "last_name",
                "data-testid": "auth_lastname_input",
                autoComplete: "off",
                label: t("auth_common:last_name")
              }, props), {
                onChange: (value) => {
                  onChange(value);
                },
                error: ((_a = errors.last_name) == null ? void 0 : _a.message) || ((_c = (_b = error == null ? void 0 : error.errors) == null ? void 0 : _b.last_name) == null ? void 0 : _c[0])
              })
            );
          }
        }
      ) })
    ] }),
    /* @__PURE__ */ jsxs7("fieldset", { className: "my-4", children: [
      /* @__PURE__ */ jsxs7("div", { className: "relative", children: [
        /* @__PURE__ */ jsx7(
          Controller3,
          {
            control,
            name: "email",
            rules: {
              required: t("auth_common:validation.required")
            },
            defaultValue: "",
            render: (_g) => {
              var { field: _h } = _g, _i = _h, { onChange } = _i, props = __objRest(_i, ["onChange"]);
              var _a, _b, _c;
              return /* @__PURE__ */ jsx7(
                Input3,
                __spreadProps(__spreadValues({
                  id: "email",
                  "data-testid": "auth_signup_email_input",
                  autoComplete: "off",
                  label: t("auth_common:email")
                }, props), {
                  onChange: (value) => {
                    onChange(value);
                  },
                  error: ((_a = errors.email) == null ? void 0 : _a.message) || ((_c = (_b = error == null ? void 0 : error.errors) == null ? void 0 : _b.email) == null ? void 0 : _c[0])
                })
              );
            }
          }
        ),
        /* @__PURE__ */ jsx7("p", { className: "text-text-secondary pt-0.5 text-sm", children: t("auth_common:validation.email_warning") }),
        emailSuggestion && /* @__PURE__ */ jsxs7(
          "div",
          {
            className: `text-text-tertiary absolute w-full rounded-lg bg-yellow-100 p-2 text-sm ${((_j = errors.email) == null ? void 0 : _j.message) || ((_l = (_k = error == null ? void 0 : error.errors) == null ? void 0 : _k.email) == null ? void 0 : _l[0]) ? "bottom-0" : "-bottom-4"}`,
            children: [
              t("auth_common:validation.did_you_mean"),
              /* @__PURE__ */ jsx7(
                "button",
                {
                  onClick: () => setValue("email", emailSuggestion.full, {
                    shouldValidate: true
                  }),
                  className: "text-primary mx-1 cursor-pointer font-semibold hover:underline",
                  children: emailSuggestion.full
                }
              )
            ]
          }
        )
      ] }),
      /* @__PURE__ */ jsx7("div", { className: "mt-4", children: /* @__PURE__ */ jsx7(
        Controller3,
        {
          control,
          name: "confirm_email",
          rules: {
            required: t("auth_common:validation.required"),
            validate: (value) => value === email || t("auth_common:validation.emails_not_match")
          },
          defaultValue: "",
          render: (_m) => {
            var { field: _n } = _m, _o = _n, { onChange } = _o, props = __objRest(_o, ["onChange"]);
            var _a, _b, _c;
            return /* @__PURE__ */ jsx7(
              Input3,
              __spreadProps(__spreadValues({
                id: "confirm_email",
                "data-testid": "auth_confirm_email_input",
                autoComplete: "off",
                label: t("auth_common:confirm_email")
              }, props), {
                onChange: (value) => {
                  onChange(value);
                },
                onPaste: (e) => {
                  e.preventDefault();
                },
                error: ((_a = errors.confirm_email) == null ? void 0 : _a.message) || ((_c = (_b = error == null ? void 0 : error.errors) == null ? void 0 : _b.confirm_email) == null ? void 0 : _c[0])
              })
            );
          }
        }
      ) })
    ] }),
    /* @__PURE__ */ jsxs7("fieldset", { children: [
      /* @__PURE__ */ jsx7(
        Controller3,
        {
          control,
          name: "password",
          rules: {
            required: t("auth_common:validation.required"),
            minLength: {
              value: 8,
              message: t("auth_common:validation.invalid_password")
            }
          },
          defaultValue: "",
          render: (_p) => {
            var { field: _q } = _p, _r = _q, { onChange } = _r, props = __objRest(_r, ["onChange"]);
            var _a, _b, _c;
            return /* @__PURE__ */ jsx7(
              Input3,
              __spreadProps(__spreadValues({}, props), {
                type: "password",
                "data-testid": "auth_signup_password_input",
                label: t("auth_common:password"),
                autoComplete: "off",
                onChange: (value) => {
                  onChange(value);
                },
                error: ((_a = errors.password) == null ? void 0 : _a.message) || ((_c = (_b = error == null ? void 0 : error.errors) == null ? void 0 : _b.password) == null ? void 0 : _c[0])
              })
            );
          }
        }
      ),
      /* @__PURE__ */ jsx7("div", { className: "mt-2", children: /* @__PURE__ */ jsx7(PasswordBullets_default, { password: password || "" }) })
    ] }),
    /* @__PURE__ */ jsx7(
      Controller3,
      {
        name: "phone",
        control,
        rules: {
          required: t("auth_common:validation.required"),
          validate: (value) => {
            var _a, _b, _c;
            const hasValidation = (_a = selectedCountry == null ? void 0 : selectedCountry.mobile_starts_with) == null ? void 0 : _a.length;
            if (value.includes(" ")) {
              return t("auth_common:validation.invalid_mobile");
            }
            if (hasValidation) {
              const validStart = (_b = selectedCountry == null ? void 0 : selectedCountry.mobile_starts_with) == null ? void 0 : _b.some(
                (start) => value.startsWith(start)
              );
              const validLength = value.length >= Number((_c = selectedCountry == null ? void 0 : selectedCountry.phone_number_lengths) == null ? void 0 : _c[0]);
              return validStart && validLength || t("auth_common:validation.invalid_mobile");
            }
          }
        },
        render: (_s) => {
          var { field: _t } = _s, _u = _t, { value } = _u, props = __objRest(_u, ["value"]);
          var _a, _b, _c, _d, _e;
          return /* @__PURE__ */ jsx7(
            MobileInput,
            __spreadProps(__spreadValues({
              lang: locale,
              label: t("auth_common:mobile")
            }, props), {
              country: selectedCountry,
              mobile: value || "",
              onChange: (name, value2) => {
                if (name === "country") {
                  setValue("selected_country", value2);
                } else {
                  setValue("phone", value2);
                }
              },
              error: ((_a = errors == null ? void 0 : errors.phone) == null ? void 0 : _a.message) || ((_c = (_b = error == null ? void 0 : error.errors) == null ? void 0 : _b.phone) == null ? void 0 : _c[0]),
              placeholder: selectedCountry ? `${((_d = selectedCountry == null ? void 0 : selectedCountry.mobile_starts_with) == null ? void 0 : _d[0]) || ""}${"x".repeat(
                (((_e = selectedCountry.phone_number_lengths) == null ? void 0 : _e[0]) || 7) - 1
              )}` : ""
            })
          );
        }
      },
      selectedCountry == null ? void 0 : selectedCountry.code
    )
  ] });
};
var SignupFormData_default = SignupFormData;

// src/components/form/Signup.tsx
import { jsx as jsx8, jsxs as jsxs8 } from "react/jsx-runtime";
var SignupForm = ({ onSuccess }) => {
  var _a, _b;
  const {
    newsLetter: { enable, organizationName },
    setTokens
  } = useAuth();
  const { locale } = useRouter5();
  const { mutateAsync: register, isPending, error } = useRegister({ lang: locale });
  const {
    getValues,
    setValue,
    watch,
    reset,
    control,
    formState: { errors }
  } = useFormContext6();
  const { t } = useTranslation8(["auth_common"]);
  const { signupEvent, trackEvent } = useAnalytics4();
  const serverErr = error;
  const errorMsg = ((_a = serverErr == null ? void 0 : serverErr.errors) == null ? void 0 : _a.user) || ((_b = serverErr == null ? void 0 : serverErr.errors) == null ? void 0 : _b.message) || (serverErr == null ? void 0 : serverErr.message) || t("auth_common:error.unknown_error");
  const step = watch("step") || "info";
  const steps = useMemo(() => {
    let data = {
      step: 1,
      text: "back_to_login",
      prevStep: "info"
    };
    switch (step) {
      case "password":
        data = {
          step: 2,
          text: "back",
          prevStep: "info"
        };
        break;
      default:
        break;
    }
    return data;
  }, [step]);
  const onSubmit = (data) => __async(void 0, null, function* () {
    try {
      const _a2 = data, { selected_country, newsletterAgree } = _a2, restData = __objRest(_a2, ["selected_country", "newsletterAgree"]);
      const referral_key = getItem("referral_key");
      const body = __spreadProps(__spreadValues({}, restData), {
        newsletter: newsletterAgree,
        country_code: selected_country == null ? void 0 : selected_country.dial_code,
        country: selected_country == null ? void 0 : selected_country.code,
        referral_key
      });
      const user = yield register({ user: body, locale });
      const updatedUser = __spreadProps(__spreadValues({}, user || {}), {
        new_user: false
      });
      setTokens({
        accessToken: updatedUser == null ? void 0 : updatedUser.access_token,
        refreshToken: updatedUser == null ? void 0 : updatedUser.refresh_token,
        tokenExpiresIn: updatedUser == null ? void 0 : updatedUser.token_expires_in
      });
      setLoggerUser2(updatedUser);
      if (onSuccess) {
        onSuccess(updatedUser);
      }
      signupEvent({ method: "email", user: updatedUser });
    } catch (error2) {
      if (error2 instanceof Exception) {
        setValue("error", error2);
      }
      trackEvent({ event: "Signup - Signup Failed", data: { email: data.email, error: error2 } });
    }
  });
  return /* @__PURE__ */ jsxs8("div", { className: "overflow-y-visible", id: "signup-wrapper", children: [
    /* @__PURE__ */ jsx8("div", { className: "relative", children: /* @__PURE__ */ jsx8("div", { className: "flex items-center justify-between", children: /* @__PURE__ */ jsx8(
      Back_default,
      {
        className: "mb-2 text-base font-medium uppercase",
        "data-testid": "auth_signup_back_to_login_button",
        onClick: () => {
          if (step === "info") {
            trackEvent({ event: "Login - Page View" });
            return setValue("mode", "email");
          }
          setValue("step", steps.prevStep);
          reset();
        },
        text: t(`auth_common:${steps.text}`)
      }
    ) }) }),
    /* @__PURE__ */ jsx8(AnimatePresence3, { initial: false, presenceAffectsLayout: true, mode: "wait", children: /* @__PURE__ */ jsx8(
      motion3.div,
      {
        className: "relative z-50 min-h-[250px]",
        initial: { x: (locale == null ? void 0 : locale.startsWith("ar")) ? "100%" : "-100%", opacity: 0 },
        animate: { x: 0, opacity: 1 },
        exit: { x: (locale == null ? void 0 : locale.startsWith("ar")) ? "-100%" : "100%", opacity: 0 },
        transition: { duration: 0.2 },
        children: /* @__PURE__ */ jsx8(SignupFormData_default, { onSubmit })
      },
      `${step}-${locale}`
    ) }),
    /* @__PURE__ */ jsxs8("div", { className: "mt-8 space-y-2", children: [
      error && errorMsg && /* @__PURE__ */ jsx8("div", { className: "text-error pb-2 text-center text-sm", children: (errorMsg == null ? void 0 : errorMsg.includes("exists")) ? /* @__PURE__ */ jsxs8(Trans, { i18nKey: "account_exists", ns: "auth_common", children: [
        /* @__PURE__ */ jsx8(
          "button",
          {
            className: "text-primary hover:underline",
            "aria-label": "Login",
            type: "button",
            onClick: () => setValue("mode", "email")
          }
        ),
        /* @__PURE__ */ jsx8(
          "button",
          {
            className: "text-primary hover:underline",
            "aria-label": "Reset Password",
            type: "button",
            onClick: () => setValue("mode", "reset-email")
          }
        )
      ] }) : /* @__PURE__ */ jsx8("p", { children: errorMsg }) }),
      /* @__PURE__ */ jsx8(
        Controller4,
        {
          name: "agreeTerms",
          control,
          rules: {
            required: t("auth_common:validation.required")
          },
          defaultValue: false,
          render: (_c) => {
            var { field: _d } = _c, _e = _d, { onChange, value } = _e, props = __objRest(_e, ["onChange", "value"]);
            var _a2;
            return /* @__PURE__ */ jsx8(
              Checkbox,
              __spreadProps(__spreadValues({}, props), {
                label: /* @__PURE__ */ jsx8("span", { className: "text-sm", children: /* @__PURE__ */ jsx8(Trans, { i18nKey: "agree", ns: "auth_common", children: /* @__PURE__ */ jsx8(
                  Button6,
                  {
                    as: Link,
                    "data-testid": "auth_terms_link",
                    shape: "text",
                    className: "text-primary px-0.5 py-px font-semibold underline",
                    href: `/${locale}/terms`,
                    children: t("auth_common:agree")
                  }
                ) }) }),
                "data-testid": "auth_terms_checkbox",
                checked: value,
                onChange: (v) => onChange(v),
                error: (_a2 = errors.agreeTerms) == null ? void 0 : _a2.message
              })
            );
          }
        }
      ),
      enable && /* @__PURE__ */ jsx8(
        Controller4,
        {
          name: "newsletterAgree",
          control,
          defaultValue: true,
          render: (_f) => {
            var { field: _g } = _f, _h = _g, { onChange, value } = _h, props = __objRest(_h, ["onChange", "value"]);
            var _a2;
            return /* @__PURE__ */ jsx8(
              Checkbox,
              __spreadProps(__spreadValues({}, props), {
                label: /* @__PURE__ */ jsx8("span", { className: "text-sm", children: /* @__PURE__ */ jsx8(
                  Trans,
                  {
                    i18nKey: "newsletterAgree",
                    ns: "auth_common",
                    values: { name: organizationName },
                    children: /* @__PURE__ */ jsx8("strong", {})
                  }
                ) }),
                checked: value,
                "data-testid": "auth_newsletter_checkbox",
                onChange: (v) => onChange(v),
                error: (_a2 = errors.newsletterAgree) == null ? void 0 : _a2.message
              })
            );
          }
        }
      ),
      /* @__PURE__ */ jsx8("div", { className: "pt-4", children: /* @__PURE__ */ jsx8(
        Button6,
        {
          type: "submit",
          form: `signup-form-${step}`,
          className: "w-full",
          onClick: () => {
            trackEvent({ event: "Signup - Signup Btn", data: { email: getValues("email") } });
          },
          loading: isPending,
          "data-testid": "auth_signup_submit_button",
          children: /* @__PURE__ */ jsx8("span", { className: "text-lg font-bold", children: t("auth_common:create_account") })
        }
      ) })
    ] })
  ] });
};
var Signup_default = SignupForm;

// src/components/form/Form.tsx
import { jsx as jsx9, jsxs as jsxs9 } from "react/jsx-runtime";
var AuthForm = ({ title, onSuccess, initialMode = "email", className }) => {
  const { locale } = useRouter6();
  const { t } = useTranslation9(["auth_common"]);
  const { country } = useGeolocation();
  const { trackEvent } = useAnalytics5();
  const methods = useForm({
    defaultValues: {
      email: "",
      mode: initialMode
    }
  });
  const mode = methods.watch("mode");
  const showHeader = useMemo2(() => {
    return ["email", "otp", "reset-otp", "reset-email", "reset-password"].includes(mode);
  }, [mode]);
  useEffect2(() => {
    if (country) {
      methods.setValue("selected_country", country);
    }
  }, [country]);
  const headerData = useMemo2(() => {
    let data = {
      steps: 2,
      activeStep: 1,
      topComponent: /* @__PURE__ */ jsx9("div", { className: "text-2xl font-bold", children: title ? t(title) : t("auth_common:signup_title") })
    };
    switch (mode) {
      case "otp":
        data = {
          steps: 2,
          activeStep: 2,
          topComponent: /* @__PURE__ */ jsx9("div", { className: "px-2", children: /* @__PURE__ */ jsx9(
            Back_default,
            {
              className: "text-base font-medium uppercase",
              onClick: () => methods.setValue("mode", "email"),
              text: t("auth_common:change_email_address"),
              id: "change-email_address"
            }
          ) })
        };
        break;
      case "reset-email":
        data = {
          steps: 3,
          activeStep: 1,
          topComponent: /* @__PURE__ */ jsxs9("div", { children: [
            /* @__PURE__ */ jsx9(
              Back_default,
              {
                onClick: () => {
                  methods.setValue("mode", "email");
                  trackEvent({ event: "Login - Page View" });
                },
                text: t("auth_common:back_to_login"),
                id: "back-login",
                "data-testid": "auth_email_form_back_to_login_button"
              }
            ),
            /* @__PURE__ */ jsx9("p", { className: "text-2xl font-bold", children: t("auth_common:reset_password_title") }),
            /* @__PURE__ */ jsx9("p", { className: "text-text-secondary text-sm", children: t("auth_common:reset_password_text") })
          ] })
        };
        break;
      case "reset-otp":
        data = {
          steps: 3,
          activeStep: 2,
          topComponent: /* @__PURE__ */ jsx9("div", { children: /* @__PURE__ */ jsx9(
            Back_default,
            {
              onClick: () => methods.setValue("mode", "email"),
              text: t("auth_common:back_to_login"),
              id: "back-login",
              "data-testid": "auth_otp_form_back_to_login_button"
            }
          ) })
        };
        break;
      case "reset-password":
        data = {
          steps: 3,
          activeStep: 3,
          topComponent: /* @__PURE__ */ jsxs9("div", { children: [
            /* @__PURE__ */ jsx9(
              Back_default,
              {
                onClick: () => {
                  methods.setValue("mode", "email");
                  trackEvent({ event: "Login - Page View" });
                },
                text: t("auth_common:back_to_login"),
                id: "back-login",
                "data-testid": "auth_new_password_form_back_to_login_button"
              }
            ),
            /* @__PURE__ */ jsx9("p", { className: "text-2xl font-bold", children: t("auth_common:reset_password_title") }),
            /* @__PURE__ */ jsx9("p", { className: "text-text-secondary text-sm", children: t("auth_common:password_description") })
          ] })
        };
        break;
      default:
        break;
    }
    return data;
  }, [methods, mode, t, title, trackEvent]);
  const FormComponent = useMemo2(() => {
    switch (mode) {
      case "otp":
      case "reset-otp":
        return /* @__PURE__ */ jsx9(OtpSignup_default, {});
      case "reset-password":
        return /* @__PURE__ */ jsx9(NewPasswordForm_default, {});
      case "reset-password-success":
        return /* @__PURE__ */ jsx9(ResetPasswordSuccess_default, {});
      case "signup":
        return /* @__PURE__ */ jsx9(Signup_default, { onSuccess });
      default:
        return /* @__PURE__ */ jsx9(Login_default, { onSuccess });
    }
  }, [mode]);
  return /* @__PURE__ */ jsx9(WithGrecaptcha, { children: /* @__PURE__ */ jsx9(FormProvider, __spreadProps(__spreadValues({}, methods), { children: /* @__PURE__ */ jsxs9(
    "div",
    {
      className: twMerge2(
        "bg-body border-input-border m-4 overflow-hidden rounded-xl border p-4",
        className
      ),
      children: [
        showHeader && /* @__PURE__ */ jsx9("div", { className: "mb-4 flex items-start justify-between gap-2", children: headerData.topComponent }),
        /* @__PURE__ */ jsx9(AnimatePresence4, { initial: false, mode: "wait", children: /* @__PURE__ */ jsx9(
          motion4.div,
          {
            initial: { x: (locale == null ? void 0 : locale.startsWith("ar")) ? "100%" : "-100%", opacity: 0 },
            animate: { x: 0, opacity: 1 },
            exit: { x: (locale == null ? void 0 : locale.startsWith("ar")) ? "-100%" : "100%", opacity: 0 },
            transition: { duration: 0.2 },
            children: FormComponent
          },
          `${mode}-${locale}-${mode}`
        ) })
      ]
    }
  ) })) });
};

// src/components/logout/LogoutModal.tsx
import { Button as Button7, Modal } from "@wbk/ui";
import { useLogout } from "@wbk/api/hooks";
import { useRouter as useRouter7, useTranslation as useTranslation10 } from "@wbk/config";
import { useAnalytics as useAnalytics6 } from "@wbk/analytics";
import { jsx as jsx10, jsxs as jsxs10 } from "react/jsx-runtime";
var LogoutModal = ({ render, onClosed }) => {
  const { locale } = useRouter7();
  const { clearTokens } = useAuth();
  const { t } = useTranslation10(["auth_common"]);
  const { mutateAsync, isPending } = useLogout({ lang: locale });
  const { logoutEvent } = useAnalytics6();
  const onConfirm = (close) => __async(void 0, null, function* () {
    try {
      yield mutateAsync();
      clearTokens();
      logoutEvent();
      close();
      if (onClosed) {
        onClosed();
      }
    } catch (error) {
    }
  });
  return /* @__PURE__ */ jsx10(
    Modal,
    {
      render,
      body: ({ close }) => /* @__PURE__ */ jsxs10("div", { className: "p-4", children: [
        /* @__PURE__ */ jsx10("div", { className: "mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-red-600/30 text-white opacity-50", children: /* @__PURE__ */ jsx10(
          "svg",
          {
            className: "h-10 w-10",
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24",
            stroke: "currentColor",
            "aria-hidden": "true",
            children: /* @__PURE__ */ jsx10(
              "path",
              {
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "1.2",
                d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              }
            )
          }
        ) }),
        /* @__PURE__ */ jsx10("p", { className: "my-6 text-center text-xl", children: t("auth_common:confirm_logout") }),
        /* @__PURE__ */ jsxs10("div", { className: "flex items-baseline justify-evenly gap-4", children: [
          /* @__PURE__ */ jsx10(
            Button7,
            {
              "data-testid": "auth_cancel_logout",
              onClick: close,
              shape: "outlined",
              theme: "white",
              className: "w-full",
              disabled: isPending,
              children: t("auth_common:cancel")
            }
          ),
          /* @__PURE__ */ jsx10(
            Button7,
            {
              "data-testid": "auth_logout",
              theme: "error",
              className: "w-full uppercase",
              onClick: () => {
                onConfirm(close);
              },
              loading: isPending,
              children: t("auth_common:logout")
            }
          )
        ] })
      ] })
    }
  );
};
var LogoutModal_default = LogoutModal;

// src/components/login/AuthModal.tsx
import { useDeviceDetect } from "@wbk/hooks";
import { BottomSheet, Modal as Modal2 } from "@wbk/ui";
import { useTranslation as useTranslation11 } from "@wbk/config";
import { jsx as jsx11 } from "react/jsx-runtime";
var AuthModal = ({ show, render, onClose, onSuccess }) => {
  const { t } = useTranslation11("auth_common");
  const { isMobile } = useDeviceDetect();
  return isMobile ? /* @__PURE__ */ jsx11(
    BottomSheet,
    {
      closeButton: true,
      sectionClassName: "pb-20",
      show,
      onClose,
      render,
      body: ({ close }) => /* @__PURE__ */ jsx11(
        AuthForm,
        {
          title: t("auth_common:login"),
          className: "m-0 border-none",
          onSuccess: (user) => {
            close();
            onSuccess == null ? void 0 : onSuccess(user);
          }
        }
      )
    }
  ) : /* @__PURE__ */ jsx11(
    Modal2,
    {
      closeButton: true,
      show,
      onClose,
      className: "max-h-svh pb-2",
      render,
      body: ({ close }) => /* @__PURE__ */ jsx11(
        AuthForm,
        {
          title: t("auth_common:login"),
          className: "m-0 border-none",
          onSuccess: (user) => {
            close();
            onSuccess == null ? void 0 : onSuccess(user);
          }
        }
      )
    }
  );
};
var AuthModal_default = AuthModal;

// src/components/profile/Menu.tsx
import { useMemo as useMemo3 } from "react";
import { Button as Button8 } from "@wbk/ui";
import {
  FlatTicketIcon,
  HeartOutlined,
  MultiplePersonIcon,
  PersonRoundedIcon,
  WalletIcon
} from "@wbk/svg";
import { Link as Link2, useRouter as useRouter8, useTranslation as useTranslation12 } from "@wbk/config";
import { useCurrency } from "@wbk/currency";
import { jsx as jsx12, jsxs as jsxs11 } from "react/jsx-runtime";
var MENU_ITEMS = [
  "my_wallet",
  "my_bookings",
  "my_info",
  "favorites_and_interests",
  "my_travelers"
];
var DEFAULT_MENU = ["my_bookings", "my_info"];
var PROFILE_LINKS = [
  {
    label: MENU_ITEMS[1],
    href: "/profile/bookings",
    isActive: (pathname) => pathname.startsWith("/profile/bookings"),
    Icon: FlatTicketIcon
  },
  {
    label: MENU_ITEMS[0],
    href: "/profile/wallet",
    isActive: (pathname) => pathname.startsWith("/profile/wallet"),
    Icon: WalletIcon
  },
  {
    label: MENU_ITEMS[2],
    href: "/profile",
    isActive: (pathname) => pathname === "/profile",
    Icon: PersonRoundedIcon
  },
  {
    label: MENU_ITEMS[3],
    href: "/profile/favorites",
    isActive: (pathname) => pathname.startsWith("/profile/favorites"),
    Icon: HeartOutlined
  },
  {
    label: MENU_ITEMS[4],
    href: "/profile/travelers",
    isActive: (pathname) => pathname.startsWith("/profile/travelers"),
    Icon: MultiplePersonIcon
  }
];
var ProfileMenu = ({ menu = DEFAULT_MENU }) => {
  const { user } = useAuth();
  const currency = useCurrency();
  const { locale } = useRouter8();
  const pathname = typeof window !== "undefined" ? window.location.pathname : "";
  const { t } = useTranslation12(["auth_common"]);
  const links = useMemo3(() => {
    const walletEnabled = (user == null ? void 0 : user.wallet_enabled) === "on" && currency.currency.shortCode === "SAR";
    if (!walletEnabled) {
      return PROFILE_LINKS.filter((m) => m.label !== "my_wallet").filter(
        (m) => menu.includes(m.label)
      );
    }
    return PROFILE_LINKS.filter((m) => menu.includes(m.label));
  }, [menu, user == null ? void 0 : user.wallet_enabled, currency.currency.shortCode]);
  return /* @__PURE__ */ jsxs11("ul", { className: "my-4 flex gap-4 overflow-x-auto p-0.5 lg:mt-4 lg:flex-col lg:gap-2", children: [
    links == null ? void 0 : links.map(({ href, label, Icon, isActive }) => {
      const active = isActive(pathname.replace(`/${locale}`, ""));
      return /* @__PURE__ */ jsx12("li", { className: "shrink-0", children: /* @__PURE__ */ jsxs11(
        Button8,
        {
          as: Link2,
          href: `/${locale}${href}`,
          shape: "text",
          theme: "action",
          "data-active": active,
          className: "hover:bg-action/10 data-[active=true]:bg-action/10 flex items-center justify-start gap-2 rounded-lg p-3",
          id: `profile-menu-${label}`,
          "data-menuitem": label,
          "data-location": "profile-menu",
          children: [
            /* @__PURE__ */ jsx12(Icon, { className: "h-6 w-6 shrink-0" }),
            t(`auth_common:${label}`)
          ]
        }
      ) }, href);
    }),
    /* @__PURE__ */ jsxs11("li", { className: "flex grow items-end justify-end lg:flex-col", children: [
      /* @__PURE__ */ jsx12("hr", { className: "border-paper hidden w-full lg:block" }),
      /* @__PURE__ */ jsx12(
        LogoutModal_default,
        {
          render: ({ open }) => /* @__PURE__ */ jsx12(
            "button",
            {
              onClick: open,
              className: "hover:bg-error text-error hover:text-error-contrast cursor-pointer rounded-lg p-3 lg:mt-6 lg:inline-flex lg:w-full",
              id: "profile-menu-logout",
              "data-menuitem": "logout",
              "data-location": "profile-menu",
              "aria-label": t("auth_common:logout"),
              children: t("auth_common:logout")
            }
          )
        }
      )
    ] })
  ] });
};

// src/components/profile/EmailEditor.tsx
import { useRef, useState } from "react";
import { WithGrecaptcha as WithGrecaptcha2 } from "@wbk/api/grecaptcha";
import { Button as Button9, Toast } from "@wbk/ui";
import { useTranslation as useTranslation13 } from "@wbk/config";
import { jsx as jsx13, jsxs as jsxs12 } from "react/jsx-runtime";
var EmailEditor = () => {
  const { user } = useAuth();
  const { t } = useTranslation13(["auth_common"]);
  const [mode, setMode] = useState();
  const toast = useRef(void 0);
  return /* @__PURE__ */ jsxs12(WithGrecaptcha2, { children: [
    /* @__PURE__ */ jsxs12("div", { className: "border-paper space-y-6 rounded-xl border p-6", children: [
      /* @__PURE__ */ jsx13("h2", { className: "text-2xl", children: t("auth_common:account_information") }),
      /* @__PURE__ */ jsxs12("div", { className: "flex items-center justify-between gap-4", children: [
        /* @__PURE__ */ jsxs12("div", { className: "line-clamp-2", children: [
          /* @__PURE__ */ jsxs12("p", { className: "text-lg font-medium", children: [
            t("auth_common:email"),
            !(user == null ? void 0 : user.email_verified) && /* @__PURE__ */ jsx13("span", { children: ` ( ${t("auth_common:not_verified")} )` })
          ] }),
          /* @__PURE__ */ jsx13("p", { className: "text-text-tertiary", children: (user == null ? void 0 : user.email) || " - " })
        ] }),
        !(user == null ? void 0 : user.email_verified) && /* @__PURE__ */ jsxs12("div", { className: "flex shrink-0 gap-2", children: [
          /* @__PURE__ */ jsx13(
            Button9,
            {
              className: "p-1 text-sm underline",
              type: "button",
              theme: "white",
              shape: "text",
              onClick: () => setMode("otp"),
              children: t("auth_common:verify")
            }
          ),
          /* @__PURE__ */ jsx13(
            Button9,
            {
              className: "p-1 text-sm underline",
              type: "button",
              theme: "white",
              shape: "text",
              onClick: () => setMode("email-update"),
              children: t("auth_common:edit")
            }
          )
        ] })
      ] })
    ] }),
    /* @__PURE__ */ jsx13(
      OtpCheckPoint,
      {
        initialMode: mode,
        show: !!mode,
        onClose: () => {
          setMode(void 0);
        },
        onSuccess: () => {
          var _a;
          setMode(void 0);
          (_a = toast.current) == null ? void 0 : _a.publish({
            title: t("auth_common:email_verified_successfully"),
            icon: true
          });
        },
        profile: true
      },
      mode
    ),
    /* @__PURE__ */ jsx13(Toast, { ref: toast })
  ] });
};
var EmailEditor_default = EmailEditor;

// src/components/profile/PersonalEditor.tsx
import { useMemo as useMemo4 } from "react";
import { COUNTRIES as COUNTRIES3, formatDate } from "@wbk/utils";
import { useRouter as useRouter11, useTranslation as useTranslation16 } from "@wbk/config";

// src/components/profile/Form.tsx
import { useEffect as useEffect3 } from "react";
import { FormProvider as FormProvider2, useForm as useForm2, useFormContext as useFormContext8 } from "react-hook-form";
import { Button as Button10, ResponsiveModal } from "@wbk/ui";
import { useUpdateProfile as useUpdateProfile2 } from "@wbk/api/hooks";
import { useGeolocation as useGeolocation2, useRouter as useRouter10, useTranslation as useTranslation15 } from "@wbk/config";
import { COUNTRIES as COUNTRIES2 } from "@wbk/utils";

// src/components/profile/FormItems.tsx
import { Controller as Controller5, useFormContext as useFormContext7 } from "react-hook-form";
import { Input as Input4, MobileInput as MobileInput2, Select, ToggleGroup } from "@wbk/ui";
import { useGetCities } from "@wbk/api/hooks";
import { COUNTRIES, dateAdd } from "@wbk/utils";
import { useRouter as useRouter9, useTranslation as useTranslation14 } from "@wbk/config";
import { Fragment, jsx as jsx14, jsxs as jsxs13 } from "react/jsx-runtime";
var ProfileFormItems = ({ error }) => {
  var _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o;
  const { locale } = useRouter9();
  const { t } = useTranslation14(["auth_common"]);
  const {
    register,
    control,
    watch,
    setValue,
    formState: { errors }
  } = useFormContext7();
  const countryOfResidence = watch("country");
  const selectedCountry = watch("dialCountry");
  const { data: cities, error: cityError } = useGetCities(
    { country: countryOfResidence || "", lang: locale },
    { enabled: !!countryOfResidence }
  );
  return /* @__PURE__ */ jsxs13(Fragment, { children: [
    /* @__PURE__ */ jsx14(
      Controller5,
      {
        name: "phone",
        control,
        rules: {
          required: t("auth_common:validation.required"),
          validate: (value) => {
            var _a, _b;
            const hasValidation = (_a = selectedCountry == null ? void 0 : selectedCountry.mobile_starts_with) == null ? void 0 : _a.length;
            if (hasValidation) {
              const validStart = (_b = selectedCountry == null ? void 0 : selectedCountry.mobile_starts_with) == null ? void 0 : _b.some(
                (start) => value == null ? void 0 : value.startsWith(start)
              );
              return validStart || t("auth_common:validation.invalid_mobile");
            }
            return true;
          }
        },
        render: (_a) => {
          var { field: _b } = _a, _c = _b, { value } = _c, props = __objRest(_c, ["value"]);
          var _a2, _b2, _c2, _d2, _e2;
          return /* @__PURE__ */ jsx14(
            MobileInput2,
            __spreadProps(__spreadValues({}, props), {
              label: t("auth_common:mobile"),
              portal: false,
              country: selectedCountry,
              mobile: value || "",
              onChange: (name, value2) => {
                if (name === "country") {
                  setValue("dialCountry", value2);
                } else {
                  setValue("phone", value2);
                }
              },
              error: ((_a2 = errors == null ? void 0 : errors.phone) == null ? void 0 : _a2.message) || ((_c2 = (_b2 = error == null ? void 0 : error.errors) == null ? void 0 : _b2.phone) == null ? void 0 : _c2[0]),
              placeholder: selectedCountry ? `${((_d2 = selectedCountry == null ? void 0 : selectedCountry.mobile_starts_with) == null ? void 0 : _d2[0]) || ""}${"x".repeat(
                (((_e2 = selectedCountry == null ? void 0 : selectedCountry.phone_number_lengths) == null ? void 0 : _e2[0]) || 7) - 1
              )}` : ""
            })
          );
        }
      },
      `phone-${selectedCountry == null ? void 0 : selectedCountry.code}`
    ),
    /* @__PURE__ */ jsx14(
      Input4,
      __spreadProps(__spreadValues({
        label: t("auth_common:first_name"),
        id: "first_name",
        error: ((_d = errors.first_name) == null ? void 0 : _d.message) || ((_f = (_e = error == null ? void 0 : error.errors) == null ? void 0 : _e.first_name) == null ? void 0 : _f[0])
      }, register("first_name", {
        required: t("auth_common:validation.required"),
        maxLength: {
          value: 25,
          message: t("auth_common:validation.max_length", { length: 25 })
        }
      })), {
        onChange: (value) => {
          setValue("first_name", value);
        }
      })
    ),
    /* @__PURE__ */ jsx14(
      Input4,
      __spreadProps(__spreadValues({
        label: t("auth_common:last_name"),
        id: "last_name",
        error: ((_g = errors.last_name) == null ? void 0 : _g.message) || ((_i = (_h = error == null ? void 0 : error.errors) == null ? void 0 : _h.last_name) == null ? void 0 : _i[0])
      }, register("last_name", {
        required: t("auth_common:validation.required"),
        maxLength: {
          value: 25,
          message: t("auth_common:validation.max_length", { length: 25 })
        }
      })), {
        onChange: (value) => {
          setValue("last_name", value);
        }
      })
    ),
    /* @__PURE__ */ jsx14(
      Controller5,
      {
        name: "gender",
        control,
        rules: { required: t("auth_common:validation.required") },
        render: ({ field }) => {
          var _a, _b, _c;
          return /* @__PURE__ */ jsx14(
            ToggleGroup,
            __spreadProps(__spreadValues({
              label: t("auth_common:gender"),
              options: [
                { text: t("auth_common:male"), value: "male" },
                { text: t("auth_common:female"), value: "female" }
              ]
            }, field), {
              type: "single",
              error: ((_a = errors.gender) == null ? void 0 : _a.message) || ((_c = (_b = error == null ? void 0 : error.errors) == null ? void 0 : _b.gender) == null ? void 0 : _c[0])
            })
          );
        }
      }
    ),
    /* @__PURE__ */ jsx14(
      Input4,
      __spreadProps(__spreadValues({
        type: "date",
        className: "uppercase",
        pattern: "\\d{4}-\\d{2}-\\d{2}",
        max: (_l = (_k = (_j = dateAdd({
          date: /* @__PURE__ */ new Date(),
          value: -MIN_AGE_ALLOWED,
          interval: "year"
        })) == null ? void 0 : _j.toISOString()) == null ? void 0 : _k.split("T")) == null ? void 0 : _l[0],
        label: t("auth_common:birthdate")
      }, register("dob", { required: t("auth_common:validation.required") })), {
        onChange: (value) => {
          setValue("dob", value);
        },
        error: ((_m = errors.dob) == null ? void 0 : _m.message) || ((_o = (_n = error == null ? void 0 : error.errors) == null ? void 0 : _n.dob) == null ? void 0 : _o[0])
      })
    ),
    /* @__PURE__ */ jsx14(
      Controller5,
      {
        name: "nationality",
        control,
        rules: { required: t("auth_common:validation.required") },
        defaultValue: "SA",
        render: (_p) => {
          var { field: _q } = _p, _r = _q, { onChange } = _r, props = __objRest(_r, ["onChange"]);
          var _a, _b, _c;
          return /* @__PURE__ */ jsx14(
            Select,
            __spreadProps(__spreadValues({}, props), {
              id: "nationality",
              autoComplete: "off",
              portal: false,
              onChange: (selected) => onChange((selected == null ? void 0 : selected.value) || ""),
              label: t("auth_common:nationality"),
              options: COUNTRIES.map((c) => ({
                id: c.code,
                value: c.code,
                text: c[`name_${locale}`] || c.name,
                icon: /* @__PURE__ */ jsx14(
                  "img",
                  {
                    className: "shrink-0",
                    src: `https://wbk-assets.s3.me-south-1.amazonaws.com/flags/w80/${c.code.toLowerCase()}.png`,
                    width: 20,
                    height: 14,
                    alt: c.name
                  }
                )
              })),
              error: ((_a = errors.nationality) == null ? void 0 : _a.message) || ((_c = (_b = error == null ? void 0 : error.errors) == null ? void 0 : _b.nationality) == null ? void 0 : _c[0])
            })
          );
        }
      }
    ),
    /* @__PURE__ */ jsx14(
      Controller5,
      {
        name: "country",
        control,
        rules: { required: t("auth_common:validation.required") },
        defaultValue: "",
        render: (_s) => {
          var { field: _t } = _s, _u = _t, { onChange } = _u, props = __objRest(_u, ["onChange"]);
          var _a, _b, _c;
          return /* @__PURE__ */ jsx14(
            Select,
            __spreadProps(__spreadValues({}, props), {
              id: "country",
              autoComplete: "off",
              portal: false,
              onChange: (selected) => {
                onChange((selected == null ? void 0 : selected.value) || "");
                setValue("city", "", { shouldValidate: true });
              },
              label: t("auth_common:country_of_residence"),
              options: COUNTRIES.map((c) => ({
                id: c.code,
                value: c.code,
                text: c[`name_${locale}`] || c.name,
                icon: /* @__PURE__ */ jsx14(
                  "img",
                  {
                    className: "shrink-0",
                    src: `https://wbk-assets.s3.me-south-1.amazonaws.com/flags/w80/${c.code.toLowerCase()}.png`,
                    width: 20,
                    height: 14,
                    alt: c.name
                  }
                )
              })),
              error: ((_a = errors.country) == null ? void 0 : _a.message) || ((_c = (_b = error == null ? void 0 : error.errors) == null ? void 0 : _b.country) == null ? void 0 : _c[0])
            })
          );
        }
      },
      `country-${countryOfResidence}`
    ),
    /* @__PURE__ */ jsx14(
      Controller5,
      {
        name: "city",
        control,
        rules: { required: t("auth_common:validation.required") },
        defaultValue: "",
        render: (_v) => {
          var { field: _w } = _v, _x = _w, { onChange } = _x, props = __objRest(_x, ["onChange"]);
          var _a, _b, _c, _d2;
          return /* @__PURE__ */ jsx14(
            Select,
            __spreadProps(__spreadValues({}, props), {
              id: "city",
              autoComplete: "off",
              portal: false,
              onChange: (selected) => onChange((selected == null ? void 0 : selected.value) || ""),
              label: t("auth_common:city"),
              options: (_a = cities || []) == null ? void 0 : _a.map((city) => ({
                id: city._id,
                value: city.name,
                text: city.name
              })),
              error: ((_b = errors.city) == null ? void 0 : _b.message) || ((_d2 = (_c = error == null ? void 0 : error.errors) == null ? void 0 : _c.city) == null ? void 0 : _d2[0]) || (cityError == null ? void 0 : cityError.message)
            })
          );
        }
      },
      `city-${countryOfResidence}-${cities == null ? void 0 : cities.length}`
    )
  ] });
};
var FormItems_default = ProfileFormItems;

// src/components/profile/Form.tsx
import { jsx as jsx15, jsxs as jsxs14 } from "react/jsx-runtime";
var ProfileForm = () => {
  const { t } = useTranslation15("auth_common");
  const methods = useForm2();
  return /* @__PURE__ */ jsx15(FormProvider2, __spreadProps(__spreadValues({}, methods), { children: /* @__PURE__ */ jsx15(
    ResponsiveModal,
    {
      title: t("auth_common:personal_information"),
      action: {
        label: t("auth_common:save_changes"),
        form: "personal-information-form",
        loading: methods.watch("loading")
      },
      render: ({ open }) => /* @__PURE__ */ jsx15(
        Button10,
        {
          className: "p-1 text-sm underline",
          type: "button",
          theme: "white",
          shape: "text",
          onClick: open,
          children: t("auth_common:edit")
        }
      ),
      body: ({ close }) => /* @__PURE__ */ jsx15(FormBody, { onClose: close })
    }
  ) }));
};
var FormBody = ({ onClose }) => {
  const { locale } = useRouter10();
  const { mutateAsync: updateProfile, error } = useUpdateProfile2({ lang: locale });
  const { setValue, handleSubmit, reset } = useFormContext8();
  const { user } = useAuth();
  const { country: detectedCountry } = useGeolocation2();
  useEffect3(() => {
    var _a;
    const dialCountry = COUNTRIES2.find((c) => c.code === (user == null ? void 0 : user.cell_country_code)) || detectedCountry;
    const phone = (_a = user == null ? void 0 : user.cell_number) == null ? void 0 : _a.replace(`+${dialCountry == null ? void 0 : dialCountry.dial_code}`, "");
    reset(__spreadProps(__spreadValues({}, getDefaultUser(user)), { dialCountry, phone }));
  }, [detectedCountry == null ? void 0 : detectedCountry.code, user == null ? void 0 : user.cell_country_code, user == null ? void 0 : user.cell_number]);
  const onSubmit = (_a) => __async(void 0, null, function* () {
    var _b = _a, { dialCountry, phone } = _b, data = __objRest(_b, ["dialCountry", "phone"]);
    var _a2;
    try {
      setValue("loading", true);
      const body = __spreadProps(__spreadValues({}, data), {
        cell_country_code: dialCountry == null ? void 0 : dialCountry.code,
        cell_number: phone,
        dob: (_a2 = data.dob) == null ? void 0 : _a2.split("-").reverse().join("/")
      });
      yield updateProfile({ user: body, locale });
      onClose();
    } finally {
      setValue("loading", false);
    }
  });
  return /* @__PURE__ */ jsxs14(
    "form",
    {
      className: "space-y-4",
      onSubmit: handleSubmit(onSubmit),
      noValidate: true,
      id: "personal-information-form",
      children: [
        /* @__PURE__ */ jsx15(FormItems_default, { error }),
        (error == null ? void 0 : error.message) && /* @__PURE__ */ jsx15("p", { className: "text-error", children: error == null ? void 0 : error.message })
      ]
    }
  );
};
var Form_default = ProfileForm;

// src/components/profile/PersonalEditor.tsx
import { Fragment as Fragment2, jsx as jsx16, jsxs as jsxs15 } from "react/jsx-runtime";
var PersonalEditor = () => {
  const { user } = useAuth();
  const { locale } = useRouter11();
  const { t } = useTranslation16(["auth_common"]);
  const country = useMemo4(() => {
    return COUNTRIES3.find((c) => c.code === (user == null ? void 0 : user.country));
  }, [user == null ? void 0 : user.country]);
  const countryName = (country == null ? void 0 : country[`name_${locale}`]) || (country == null ? void 0 : country.name);
  const residence = (user == null ? void 0 : user.city) ? `${user.city}, ${countryName}` : countryName;
  return /* @__PURE__ */ jsxs15("div", { className: "border-paper space-y-6 rounded-xl border p-6", children: [
    /* @__PURE__ */ jsxs15("div", { className: "flex justify-between gap-4", children: [
      /* @__PURE__ */ jsx16("h2", { className: "text-2xl", children: t("auth_common:personal_information") }),
      /* @__PURE__ */ jsx16(Form_default, {})
    ] }),
    /* @__PURE__ */ jsxs15("div", { className: "line-clamp-2", children: [
      /* @__PURE__ */ jsx16("p", { className: "text-lg font-medium", children: t("auth_common:name") }),
      /* @__PURE__ */ jsx16("p", { className: "text-text-tertiary", children: (user == null ? void 0 : user.name) || " - " })
    ] }),
    (user == null ? void 0 : user.dob) && /* @__PURE__ */ jsxs15(Fragment2, { children: [
      /* @__PURE__ */ jsx16("hr", { className: "border-paper" }),
      /* @__PURE__ */ jsxs15("div", { className: "line-clamp-2", children: [
        /* @__PURE__ */ jsx16("p", { className: "text-lg font-medium", children: t("auth_common:birthdate") }),
        /* @__PURE__ */ jsx16("p", { className: "text-text-tertiary", children: formatDate(user.dob, locale, { dateStyle: "medium" }) || " - " })
      ] })
    ] }),
    /* @__PURE__ */ jsx16("hr", { className: "border-paper" }),
    /* @__PURE__ */ jsxs15("div", { className: "line-clamp-2", children: [
      /* @__PURE__ */ jsx16("p", { className: "text-lg font-medium", children: t("auth_common:mobile") }),
      /* @__PURE__ */ jsx16("p", { className: "text-text-tertiary", children: `0${user == null ? void 0 : user.cell_number}` })
    ] }),
    /* @__PURE__ */ jsx16("hr", { className: "border-paper" }),
    /* @__PURE__ */ jsxs15("div", { className: "line-clamp-2", children: [
      /* @__PURE__ */ jsx16("p", { className: "text-lg font-medium", children: t("auth_common:gender") }),
      /* @__PURE__ */ jsx16("p", { className: "text-text-tertiary", children: t(`auth_common:${(user == null ? void 0 : user.gender) || "male"}`) })
    ] }),
    /* @__PURE__ */ jsx16("hr", { className: "border-paper" }),
    /* @__PURE__ */ jsxs15("div", { className: "line-clamp-2", children: [
      /* @__PURE__ */ jsx16("p", { className: "text-lg font-medium", children: t("auth_common:nationality") }),
      /* @__PURE__ */ jsx16("p", { className: "text-text-tertiary", children: (user == null ? void 0 : user.nationality) || " - " })
    ] }),
    /* @__PURE__ */ jsx16("hr", { className: "border-paper" }),
    /* @__PURE__ */ jsxs15("div", { className: "line-clamp-2", children: [
      /* @__PURE__ */ jsx16("p", { className: "text-lg font-medium", children: t("auth_common:residence") }),
      /* @__PURE__ */ jsx16("p", { className: "text-text-tertiary", children: residence || " - " })
    ] })
  ] });
};
var PersonalEditor_default = PersonalEditor;

// src/components/profile/Profile.tsx
import { jsx as jsx17, jsxs as jsxs16 } from "react/jsx-runtime";
var UserProfile = () => {
  return /* @__PURE__ */ jsxs16("div", { className: "mb-4 space-y-6", children: [
    /* @__PURE__ */ jsx17(EmailEditor_default, {}),
    /* @__PURE__ */ jsx17(PersonalEditor_default, {})
  ] });
};

// src/components/profile/ProfileTop.tsx
import { Button as Button11, Typography } from "@wbk/ui";
import { formatDate as formatDate2 } from "@wbk/utils";
import { Link as Link3, Trans as Trans2, useRouter as useRouter12, useTranslation as useTranslation17 } from "@wbk/config";
import { SubscriptionIcon } from "@wbk/svg";
import { useAnalytics as useAnalytics7 } from "@wbk/analytics";
import { jsx as jsx18, jsxs as jsxs17 } from "react/jsx-runtime";
var ProfileTop = ({ subscription }) => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const { user } = useAuth();
  const { locale } = useRouter12();
  const { t } = useTranslation17("auth_common");
  const { trackEvent } = useAnalytics7();
  if (!user)
    return null;
  const plan = subscription == null ? void 0 : subscription.plan;
  const PlanComp = (subscription == null ? void 0 : subscription.is_cancelled) ? Link3 : "div";
  return /* @__PURE__ */ jsxs17("div", { className: "space-y-2", children: [
    /* @__PURE__ */ jsxs17("div", { className: "border-paper-level-1 rounded-S w-full overflow-hidden border", children: [
      /* @__PURE__ */ jsxs17("div", { className: "flex items-center gap-5 p-5", children: [
        /* @__PURE__ */ jsxs17("div", { className: "bg-primary text-primary-contrast relative flex h-12 w-12 shrink-0 items-center justify-center rounded-full text-xl font-bold uppercase sm:mb-0", children: [
          (_d = (_c = (_b = (_a = user.name) == null ? void 0 : _a.split) == null ? void 0 : _b.call(_a, " ")) == null ? void 0 : _c[0]) == null ? void 0 : _d[0],
          (_h = (_g = (_f = (_e = user.name) == null ? void 0 : _e.split) == null ? void 0 : _f.call(_e, " ")) == null ? void 0 : _g[1]) == null ? void 0 : _h[0]
        ] }),
        /* @__PURE__ */ jsx18(Typography, { variant: "heading-S", children: user.name })
      ] }),
      !!plan && /* @__PURE__ */ jsx18("div", { className: "bg-paper-level-1 border-paper-level-1 border-t px-5 py-2", children: /* @__PURE__ */ jsxs17("div", { className: "flex items-center justify-between", children: [
        /* @__PURE__ */ jsxs17(
          PlanComp,
          {
            to: `/${locale}/subscriptions/manage/${plan.plan_group._id}`,
            className: "flex items-center gap-2",
            children: [
              plan.icon && /* @__PURE__ */ jsx18(
                "img",
                {
                  src: plan.icon,
                  className: "h-5 w-5 shrink-0 object-contain",
                  alt: plan.plan_group.name
                }
              ),
              /* @__PURE__ */ jsx18(Typography, { strong: true, children: plan.plan_group.name })
            ]
          }
        ),
        plan.is_basic_plan || subscription.is_cancelled ? /* @__PURE__ */ jsxs17(Button11, { as: Link3, href: `/${locale}/subscriptions`, className: "shrink-0 p-2", children: [
          /* @__PURE__ */ jsx18(SubscriptionIcon, { className: "h-4 w-4 shrink-0" }),
          /* @__PURE__ */ jsx18(
            Typography,
            {
              variant: "body-S",
              strong: true,
              onClick: () => {
                trackEvent({ event: "Header - Subscription Upgrade" });
              },
              children: t("auth_common:upgrade")
            }
          )
        ] }) : /* @__PURE__ */ jsx18(
          Button11,
          {
            arrow: true,
            shape: "text",
            theme: "action",
            as: Link3,
            href: `/${locale}/subscriptions/manage/${plan.plan_group._id}`,
            className: "shrink-0 p-2",
            onClick: () => {
              trackEvent({ event: "user_subscription_plan" });
              trackEvent({ event: "Header - Subscription View" });
            },
            children: /* @__PURE__ */ jsx18(Typography, { variant: "body-S", strong: true, children: t("auth_common:view_benefits") })
          }
        )
      ] }) })
    ] }),
    !!(subscription == null ? void 0 : subscription.plan) && subscription.is_cancelled && /* @__PURE__ */ jsx18("p", { className: "text-text-secondary text-sm", children: /* @__PURE__ */ jsx18(
      Trans2,
      {
        i18nKey: "subscription_cancelled_benefits_expired",
        ns: "auth_common",
        values: {
          date: formatDate2(subscription.end_date, locale, {
            day: "numeric",
            month: "short",
            year: "numeric"
          })
        },
        children: /* @__PURE__ */ jsx18("span", { className: "text-error" })
      }
    ) })
  ] });
};

// src/components/wrappers/WithAuth.tsx
import { AnimatedWbkLogo } from "@wbk/svg";
import { useDeviceDetect as useDeviceDetect2 } from "@wbk/hooks";
import { Fragment as Fragment3, jsx as jsx19, jsxs as jsxs18 } from "react/jsx-runtime";
var WithAuth = (Component, config) => {
  const WithAuthComponent = (props) => {
    const { user, isNewUser, loading } = useAuth({ autoFetch: true });
    const { isWebView } = useDeviceDetect2();
    if (loading) {
      return /* @__PURE__ */ jsxs18(Fragment3, { children: [
        /* @__PURE__ */ jsx19("style", { children: "body{overflow:hidden}" }),
        (config == null ? void 0 : config.loadingComponent) || /* @__PURE__ */ jsx19("div", { className: "relative flex h-[calc(100svh-50px)] items-center justify-center overflow-hidden rounded-md py-20", children: /* @__PURE__ */ jsx19(AnimatedWbkLogo, { className: "h-24 w-24" }) })
      ] });
    }
    if (!user || isNewUser) {
      return /* @__PURE__ */ jsx19(
        "section",
        {
          "data-webview": !!isWebView,
          className: "after:bg-body/80 relative flex min-h-[95vh] items-center after:absolute after:inset-0 data-[webview=false]:before:absolute data-[webview=false]:before:inset-0 data-[webview=false]:before:z-[-1] data-[webview=false]:before:bg-[url(/images/default-cover.jpg)] data-[webview=false]:before:bg-cover data-[webview=false]:before:bg-no-repeat",
          children: /* @__PURE__ */ jsxs18("div", { className: "container relative z-10 mx-auto grid grid-cols-1 py-10 lg:grid-cols-2", children: [
            !isWebView && /* @__PURE__ */ jsx19("div", { className: "flex items-center pb-8", children: /* @__PURE__ */ jsx19("figure", { className: "mx-auto w-full", children: /* @__PURE__ */ jsx19(
              "img",
              {
                className: "mx-auto h-full max-h-[100px] w-full max-w-[160px] lg:max-w-xs",
                src: "/icons/logo.svg",
                alt: ""
              }
            ) }) }),
            /* @__PURE__ */ jsx19("div", { className: "mx-auto w-full max-w-lg", children: /* @__PURE__ */ jsx19(AuthForm, { title: config == null ? void 0 : config.title, className: "m-0" }) })
          ] })
        }
      );
    }
    return /* @__PURE__ */ jsx19(Component, __spreadProps(__spreadValues({}, props), { user }));
  };
  return WithAuthComponent;
};

// src/context/provider.tsx
import { jsx as jsx20, jsxs as jsxs19 } from "react/jsx-runtime";
var tokenRefreshTimeoutId;
var AuthProvider = (_a) => {
  var _b = _a, {
    children,
    refreshToken = true,
    autoInit = true
  } = _b, props = __objRest(_b, [
    "children",
    "refreshToken",
    "autoInit"
  ]);
  var _a2, _b2, _c;
  const [state, setState] = useState2(__spreadProps(__spreadValues({}, props), {
    refreshToken,
    canFetchUser: !refreshToken,
    autoInit
  }));
  const { loginEvent } = useAnalytics8();
  const { locale } = useRouter13();
  const {
    data: user,
    isPending,
    isFetching
  } = useGetUser({ lang: locale }, { enabled: state.autoInit && state.canFetchUser });
  const fetchUser = () => {
    if (state.autoInit)
      return;
    setState((prev) => __spreadProps(__spreadValues({}, prev), { autoInit: true }));
  };
  const setTokens = ({
    accessToken,
    refreshToken: refreshToken2,
    tokenExpiresIn
  }) => {
    var _a3, _b3, _c2, _d, _e, _f, _g, _h, _i, _j, _k;
    const tokenExpiryTime = tokenExpiresIn ? Date.now() + tokenExpiresIn * 1e3 : void 0;
    const expiresIn = tokenExpiresIn ? tokenExpiresIn / (60 * 60 * 24) : (_b3 = (_a3 = ApiConfig.config) == null ? void 0 : _a3.cookie) == null ? void 0 : _b3.tokenExpiration;
    if (accessToken) {
      createCookie({
        name: COOKIE_TOKEN,
        value: accessToken,
        expiration: expiresIn,
        domain: (_e = (_d = (_c2 = ApiConfig) == null ? void 0 : _c2.config) == null ? void 0 : _d.cookie) == null ? void 0 : _e.domain
      });
    }
    if (refreshToken2) {
      createCookie({
        name: COOKIE_REFRESH_TOKEN,
        value: refreshToken2,
        expiration: Number.MAX_SAFE_INTEGER,
        domain: (_h = (_g = (_f = ApiConfig) == null ? void 0 : _f.config) == null ? void 0 : _g.cookie) == null ? void 0 : _h.domain
      });
    }
    if (tokenExpiryTime) {
      createCookie({
        name: COOKIE_TOKEN_EXPIRES_IN,
        value: tokenExpiryTime.toString(),
        expiration: Number.MAX_SAFE_INTEGER,
        domain: (_k = (_j = (_i = ApiConfig) == null ? void 0 : _i.config) == null ? void 0 : _j.cookie) == null ? void 0 : _k.domain
      });
    }
    if (refreshToken2 && tokenExpiresIn) {
      startRefreshTokenTimer(refreshToken2, tokenExpiresIn);
    }
  };
  const updateTokens = (refreshToken2) => __async(void 0, null, function* () {
    var _a3, _b3;
    try {
      const url = `https://www.google.com/recaptcha/api.js?render=${(_b3 = (_a3 = ApiConfig.config) == null ? void 0 : _a3.grecaptcha) == null ? void 0 : _b3.v3Key}`;
      yield loadScriptAsync({ id: "recaptcha_script", url });
      const { data } = yield refreshTokens(refreshToken2);
      setTokens({
        accessToken: data.access_token,
        refreshToken: data.refresh_token,
        tokenExpiresIn: data.token_expires_in
      });
    } finally {
      setState((prev) => __spreadProps(__spreadValues({}, prev), { canFetchUser: true }));
    }
  });
  const startRefreshTokenTimer = (refreshToken2, tokenExpiresIn) => {
    if (!state.refreshToken)
      return;
    if (tokenRefreshTimeoutId) {
      clearTimeout(tokenRefreshTimeoutId);
    }
    const timeRemaining = tokenExpiresIn * 1e3;
    tokenRefreshTimeoutId = setTimeout(() => {
      updateTokens(refreshToken2);
    }, timeRemaining);
  };
  const clearTokens = () => {
    var _a3, _b3, _c2, _d, _e, _f, _g, _h, _i;
    if (tokenRefreshTimeoutId) {
      clearTimeout(tokenRefreshTimeoutId);
    }
    eraseCookie(COOKIE_TOKEN, (_c2 = (_b3 = (_a3 = ApiConfig) == null ? void 0 : _a3.config) == null ? void 0 : _b3.cookie) == null ? void 0 : _c2.domain);
    eraseCookie(COOKIE_REFRESH_TOKEN, (_f = (_e = (_d = ApiConfig) == null ? void 0 : _d.config) == null ? void 0 : _e.cookie) == null ? void 0 : _f.domain);
    eraseCookie(COOKIE_TOKEN_EXPIRES_IN, (_i = (_h = (_g = ApiConfig) == null ? void 0 : _g.config) == null ? void 0 : _h.cookie) == null ? void 0 : _i.domain);
  };
  useEffect4(() => {
    const storageRefreshToken = readCookie(COOKIE_REFRESH_TOKEN);
    const storageTokenExpiresIn = readCookie(COOKIE_TOKEN_EXPIRES_IN);
    if (!storageRefreshToken || !storageTokenExpiresIn) {
      setState((prev) => __spreadProps(__spreadValues({}, prev), { canFetchUser: true }));
      return;
    }
    const expiryTime = parseInt(storageTokenExpiresIn, 10);
    const timeRemaining = expiryTime - Date.now();
    if (timeRemaining > 0) {
      startRefreshTokenTimer(storageRefreshToken, timeRemaining / 1e3);
      setState((prev) => __spreadProps(__spreadValues({}, prev), { canFetchUser: true }));
    } else {
      updateTokens(storageRefreshToken);
    }
  }, []);
  const isNewUser = useMemo5(() => {
    return !!(user == null ? void 0 : user._id) && (!!(user == null ? void 0 : user.is_guest) || !!(user == null ? void 0 : user.force_verify_email));
  }, [user == null ? void 0 : user._id, user == null ? void 0 : user.force_verify_email, user == null ? void 0 : user.is_guest]);
  const isTawakkalnaUser = useMemo5(() => {
    return readCookie("twk") === "true";
  }, []);
  useEffect4(() => {
    if (user) {
      loginEvent({
        method: "email",
        user: __spreadProps(__spreadValues({}, user), { locale })
      });
    }
  }, [user]);
  return /* @__PURE__ */ jsxs19(
    context_default.Provider,
    {
      value: __spreadProps(__spreadValues({}, state), {
        newsLetter: {
          enable: (_b2 = (_a2 = props.newsLetter) == null ? void 0 : _a2.enable) != null ? _b2 : true,
          organizationName: ((_c = props.newsLetter) == null ? void 0 : _c.organizationName) || "webook.com"
        },
        user,
        isNewUser,
        isTawakkalnaUser,
        loading: isPending,
        isFetching,
        fetchUser,
        setTokens,
        clearTokens
      }),
      children: [
        /* @__PURE__ */ jsx20(ForceUpdateProfileCheckPoint, {}),
        children
      ]
    }
  );
};

// src/components/checkpoint/global/Entry.tsx
import { useTranslation as useTranslation18 } from "@wbk/config";
import { StrokeCheckIcon } from "@wbk/svg";
import { Typography as Typography2 } from "@wbk/ui";
import { jsx as jsx21, jsxs as jsxs20 } from "react/jsx-runtime";
var Entry = () => {
  const { t } = useTranslation18("auth_common");
  return /* @__PURE__ */ jsxs20("div", { children: [
    /* @__PURE__ */ jsx21("img", { src: "/@wbk/auth/account-details.png", alt: "account-details", width: 480, height: 215 }),
    /* @__PURE__ */ jsx21(Typography2, { variant: "heading-L", className: "mb-4", children: t("auth_common:force_complete_profile.title") }),
    /* @__PURE__ */ jsxs20("ul", { className: "mb-4 space-y-6", children: [
      /* @__PURE__ */ jsxs20("li", { className: "flex items-center gap-3", children: [
        /* @__PURE__ */ jsx21(StrokeCheckIcon, { className: "h-6 w-6 shrink-0" }),
        /* @__PURE__ */ jsxs20("div", { className: "space-y-1", children: [
          /* @__PURE__ */ jsx21(Typography2, { variant: "label-M", children: t("auth_common:force_complete_profile.tailored_deals") }),
          /* @__PURE__ */ jsx21(Typography2, { variant: "body-S", color: "text-secondary", children: t("auth_common:force_complete_profile.tailored_deals_desc") })
        ] })
      ] }),
      /* @__PURE__ */ jsxs20("li", { className: "flex items-center gap-3", children: [
        /* @__PURE__ */ jsx21(StrokeCheckIcon, { className: "h-6 w-6 shrink-0" }),
        /* @__PURE__ */ jsxs20("div", { className: "space-y-1", children: [
          /* @__PURE__ */ jsx21(Typography2, { variant: "label-M", children: t("auth_common:force_complete_profile.enhance_security") }),
          /* @__PURE__ */ jsx21(Typography2, { variant: "body-S", color: "text-secondary", children: t("auth_common:force_complete_profile.enhance_security_desc") })
        ] })
      ] }),
      /* @__PURE__ */ jsxs20("li", { className: "flex items-center gap-3", children: [
        /* @__PURE__ */ jsx21(StrokeCheckIcon, { className: "h-6 w-6 shrink-0" }),
        /* @__PURE__ */ jsxs20("div", { className: "space-y-1", children: [
          /* @__PURE__ */ jsx21(Typography2, { variant: "label-M", children: t("auth_common:force_complete_profile.keep_access_to_webook") }),
          /* @__PURE__ */ jsx21(Typography2, { variant: "body-S", color: "text-secondary", children: t("auth_common:force_complete_profile.keep_access_to_webook_desc") })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ jsx21(Typography2, { children: t("auth_common:force_complete_profile.only_takes_a_minute") })
  ] });
};
var Entry_default = Entry;

// src/components/checkpoint/global/Form.tsx
import { useEffect as useEffect5 } from "react";
import { useFormContext as useFormContext9 } from "react-hook-form";
import { useUpdateProfile as useUpdateProfile3 } from "@wbk/api/hooks";
import { useGeolocation as useGeolocation3, useRouter as useRouter14, useTranslation as useTranslation19 } from "@wbk/config";
import { Typography as Typography3 } from "@wbk/ui";
import { WbkLogo as WbkLogo2 } from "@wbk/svg";
import { COUNTRIES as COUNTRIES4 } from "@wbk/utils";
import { Fragment as Fragment4, jsx as jsx22, jsxs as jsxs21 } from "react/jsx-runtime";
var UpdateProfileForm = ({ onClose }) => {
  const { t } = useTranslation19("auth_common");
  const { handleSubmit, setValue, reset } = useFormContext9();
  const { locale } = useRouter14();
  const { mutateAsync: updateProfile, error } = useUpdateProfile3({ lang: locale });
  const { country: detectedCountry } = useGeolocation3();
  const { user } = useAuth();
  useEffect5(() => {
    const dialCountry = COUNTRIES4.find((c) => c.code === (user == null ? void 0 : user.cell_country_code)) || detectedCountry;
    reset(__spreadProps(__spreadValues({}, getDefaultUser(user)), {
      dialCountry,
      // Global check point should force user to re-enter the below
      nationality: "",
      country: "",
      city: "",
      phone: ""
    }));
  }, [detectedCountry == null ? void 0 : detectedCountry.code, user == null ? void 0 : user.cell_country_code, user == null ? void 0 : user.cell_number]);
  const onSubmit = (_a) => __async(void 0, null, function* () {
    var _b = _a, { dialCountry, phone, loading: _loading } = _b, data = __objRest(_b, ["dialCountry", "phone", "loading"]);
    var _a2;
    try {
      setValue("loading", true);
      const body = __spreadProps(__spreadValues({}, data), {
        cell_country_code: dialCountry == null ? void 0 : dialCountry.code,
        cell_number: phone,
        dob: (_a2 = data.dob) == null ? void 0 : _a2.split("-").reverse().join("/"),
        passport_data: void 0
      });
      yield updateProfile({ user: body, locale });
      onClose == null ? void 0 : onClose();
    } finally {
      setValue("loading", false);
    }
  });
  return /* @__PURE__ */ jsxs21(Fragment4, { children: [
    /* @__PURE__ */ jsx22(WbkLogo2, { className: "text-primary w-16" }),
    /* @__PURE__ */ jsx22(Typography3, { as: "h2", variant: "heading-XXL", className: "mb-6", children: t("auth_common:force_complete_profile.update_information") }),
    /* @__PURE__ */ jsx22("form", { id: "profile-form", onSubmit: handleSubmit(onSubmit), className: "space-y-4", children: /* @__PURE__ */ jsx22(FormItems_default, { error }) })
  ] });
};

// src/components/checkpoint/global/index.tsx
import { jsx as jsx23, jsxs as jsxs22 } from "react/jsx-runtime";
var ForceUpdateProfileCheckPoint = () => {
  const [showBar, setShowBar] = useState3(false);
  const modal = useRef2(void 0);
  const { t } = useTranslation20("auth_common");
  const { locale } = useRouter15();
  const { user } = useAuth();
  const { trackEvent } = useAnalytics9();
  const methods = useForm3({
    defaultValues: { mode: "entry" }
  });
  const mode = methods.watch("mode");
  useEffect6(() => {
    var _a;
    if (user == null ? void 0 : user.force_update) {
      (_a = modal.current) == null ? void 0 : _a.open();
    }
  }, [user == null ? void 0 : user.force_update]);
  return /* @__PURE__ */ jsx23(FormProvider3, __spreadProps(__spreadValues({}, methods), { children: /* @__PURE__ */ jsx23(
    ResponsiveModal2,
    {
      ref: modal,
      size: "lg",
      onClose: () => {
        setShowBar(true);
        methods.setValue("mode", "entry");
        trackEvent({
          event: "force_update_screen_exit",
          data: {
            user_id: user == null ? void 0 : user._id
          }
        });
      },
      cancel: {
        label: mode === "entry" ? t("auth_common:force_complete_profile.skip_for_now") : t("auth_common:force_complete_profile.cancel"),
        onClick: ({ close }) => close()
      },
      action: {
        label: mode === "entry" ? t("auth_common:force_complete_profile.update_information") : t("auth_common:force_complete_profile.save"),
        loading: methods.watch("loading"),
        form: "profile-form",
        onClick: () => {
          if (mode === "entry") {
            methods.setValue("mode", "form");
          }
          trackEvent({
            event: "force_update_screen_save_info",
            data: {
              user_id: user == null ? void 0 : user._id
            }
          });
        }
      },
      render: ({ open }) => /* @__PURE__ */ jsx23(
        "div",
        {
          className: "h-0 overflow-hidden bg-[#7B49FF] transition-all data-[open=true]:h-16",
          "data-open": showBar && !!(user == null ? void 0 : user.force_update),
          children: /* @__PURE__ */ jsxs22("div", { className: "container flex h-16 items-center justify-between gap-3 py-4 text-white", children: [
            /* @__PURE__ */ jsxs22("div", { className: "flex items-center gap-4", children: [
              /* @__PURE__ */ jsx23(ExclamationTriangleIcon, { className: "h-6 w-6" }),
              /* @__PURE__ */ jsx23(Typography4, { className: "text-sm font-medium", variant: "body-M", children: t("auth_common:force_complete_profile.update_profile_to_keep_using_webook") })
            ] }),
            /* @__PURE__ */ jsxs22(
              Button12,
              {
                theme: "action",
                onClick: () => {
                  open();
                  setShowBar(false);
                  trackEvent({
                    event: "force_update_banner_spotlight_clicked",
                    data: {
                      user_id: user == null ? void 0 : user._id
                    }
                  });
                },
                className: "h-9 shrink-0",
                children: [
                  /* @__PURE__ */ jsx23("span", { className: "hidden md:block", children: t("auth_common:force_complete_profile.update_information") }),
                  /* @__PURE__ */ jsx23("span", { className: "block md:hidden", children: t("auth_common:force_complete_profile.update") })
                ]
              }
            )
          ] })
        }
      ),
      body: ({ close }) => /* @__PURE__ */ jsx23(AnimatePresence5, { initial: false, mode: "wait", children: /* @__PURE__ */ jsx23(
        motion5.div,
        {
          initial: { x: (locale == null ? void 0 : locale.startsWith("ar")) ? "100%" : "-100%", opacity: 0 },
          animate: { x: 0, opacity: 1 },
          exit: { x: (locale == null ? void 0 : locale.startsWith("ar")) ? "-100%" : "100%", opacity: 0 },
          transition: { duration: 0.2 },
          children: mode === "entry" ? /* @__PURE__ */ jsx23(Entry_default, {}) : /* @__PURE__ */ jsx23(
            UpdateProfileForm,
            {
              onClose: () => {
                close();
                setShowBar(false);
              }
            }
          )
        },
        `${mode}-${locale}`
      ) })
    }
  ) }));
};

// src/components/checkpoint/nafath/index.tsx
import { useEffect as useEffect7, useRef as useRef3, useState as useState4 } from "react";
import { Controller as Controller6, useForm as useForm4 } from "react-hook-form";
import { twMerge as twMerge3 } from "tailwind-merge";
import { Button as Button13, Input as Input5 } from "@wbk/ui";
import { useCheckNafath, useRequestNafath } from "@wbk/api/hooks";
import { useRouter as useRouter16, useTranslation as useTranslation21 } from "@wbk/config";
import { jsx as jsx24, jsxs as jsxs23 } from "react/jsx-runtime";
var NafathCheckPoint = ({ className }) => {
  var _d;
  const { locale } = useRouter16();
  const { t } = useTranslation21(["auth_common"]);
  const [mode, setMode] = useState4("iqama");
  const retryRef = useRef3(void 0);
  const { data: nafathData, mutateAsync, isPending, error: reqError } = useRequestNafath();
  const { mutateAsync: checkNafath, error: checkError, reset } = useCheckNafath({ lang: locale });
  const {
    handleSubmit,
    formState: { errors },
    control
  } = useForm4({
    defaultValues: {
      user_id: ""
    }
  });
  const onSubmit = (data) => __async(void 0, null, function* () {
    try {
      reset();
      if (retryRef.current) {
        clearInterval(retryRef.current);
      }
      const res = yield mutateAsync({ id: data.user_id, locale });
      setMode("code");
      retryRef.current = setInterval(() => __async(void 0, null, function* () {
        try {
          yield checkNafath({
            id: data.user_id,
            transId: res.data.transId,
            code: res.data.code,
            locale
          });
        } catch (error) {
          clearInterval(retryRef.current);
        }
      }), 5e3);
    } catch (err) {
    }
  });
  useEffect7(() => {
    return () => {
      if (retryRef.current) {
        clearInterval(retryRef.current);
      }
    };
  }, []);
  return /* @__PURE__ */ jsx24("div", { className: twMerge3("p-4 py-12", className), children: /* @__PURE__ */ jsx24("div", { className: "bg-body-level-1 mx-auto max-w-lg rounded-md", children: mode === "iqama" ? /* @__PURE__ */ jsxs23(
    "form",
    {
      id: "checkout-complete-nafath",
      onSubmit: handleSubmit(onSubmit),
      className: "space-y-4 p-4",
      children: [
        /* @__PURE__ */ jsxs23("div", { children: [
          /* @__PURE__ */ jsx24("h2", { className: "pb-8 text-2xl font-semibold md:text-3xl", children: t("auth_common:nafath_title") }),
          /* @__PURE__ */ jsx24(
            "img",
            {
              width: 37,
              height: 16,
              className: "object-contain",
              src: "/@wbk/auth/nafath-title.png",
              alt: "nafath title"
            }
          ),
          /* @__PURE__ */ jsxs23("div", { className: "mt-4 flex items-start gap-5", children: [
            /* @__PURE__ */ jsx24("p", { className: "text-text-secondary flex-1 text-base md:text-lg", children: t("auth_common:nafath_decs") }),
            /* @__PURE__ */ jsx24(
              "img",
              {
                className: "object-contain",
                width: 94,
                height: 102,
                src: "/@wbk/auth/nafath-logo.png",
                alt: "nafath logo"
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ jsx24("fieldset", { children: /* @__PURE__ */ jsx24(
          Controller6,
          {
            control,
            name: "user_id",
            rules: {
              required: t("auth_common:validation.required"),
              minLength: {
                value: 10,
                message: t("auth_common:validation.min_length", { min: 10 })
              },
              maxLength: {
                value: 10,
                message: t("auth_common:validation.max_length", { max: 10 })
              }
            },
            render: (_a) => {
              var { field: _b } = _a, _c = _b, { onChange } = _c, props = __objRest(_c, ["onChange"]);
              var _a2;
              return /* @__PURE__ */ jsx24(
                Input5,
                __spreadValues({
                  id: "user_id",
                  inputMode: "numeric",
                  label: t("auth_common:nafath_id"),
                  onChange: (value) => {
                    const valid = /^[0-9]*$/.test(value);
                    if (valid && value.length <= 10) {
                      onChange(value);
                    }
                  },
                  error: (_a2 = errors.user_id) == null ? void 0 : _a2.message
                }, props)
              );
            }
          }
        ) }),
        (reqError == null ? void 0 : reqError.message) && /* @__PURE__ */ jsx24("p", { className: "text-error", children: reqError.message }),
        /* @__PURE__ */ jsx24(
          Button13,
          {
            className: "w-full text-[#0D9488]",
            theme: "white",
            type: "submit",
            form: "checkout-complete-nafath",
            loading: isPending,
            children: /* @__PURE__ */ jsx24("span", { className: "text-lg font-bold", children: t("auth_common:connect_nafath") })
          }
        )
      ]
    }
  ) : /* @__PURE__ */ jsxs23("div", { className: "space-y-4 p-4", children: [
    /* @__PURE__ */ jsx24(
      "img",
      {
        width: 37,
        height: 16,
        className: "object-contain",
        src: "/@wbk/auth/nafath-title.png",
        alt: "nafath title"
      }
    ),
    /* @__PURE__ */ jsx24("p", { className: "text-base md:text-lg", children: t("auth_common:nafath_code") }),
    /* @__PURE__ */ jsx24("h2", { className: "bg-body-level-2 mx-auto flex h-16 w-16 items-center justify-center rounded-full p-2", children: ((_d = nafathData == null ? void 0 : nafathData.data) == null ? void 0 : _d.code) || "00" }),
    (checkError == null ? void 0 : checkError.message) && /* @__PURE__ */ jsxs23("div", { children: [
      /* @__PURE__ */ jsx24("p", { className: "text-error", children: checkError == null ? void 0 : checkError.message }),
      /* @__PURE__ */ jsx24(
        Button13,
        {
          theme: "white",
          shape: "outlined",
          className: "mt-4 w-full",
          onClick: () => setMode("iqama"),
          children: /* @__PURE__ */ jsx24("span", { className: "text-lg font-bold", children: t("auth_common:change_id") })
        }
      )
    ] })
  ] }) }) });
};

// src/components/checkpoint/otp/index.tsx
import { useRef as useRef4 } from "react";
import { FormProvider as FormProvider4, useForm as useForm5 } from "react-hook-form";
import { twMerge as twMerge4 } from "tailwind-merge";
import { BottomSheet as BottomSheet2, Modal as Modal3, Toast as Toast2 } from "@wbk/ui";
import { useDeviceDetect as useDeviceDetect3 } from "@wbk/hooks";
import { AnimatePresence as AnimatePresence6, motion as motion6 } from "motion/react";
import { useRouter as useRouter20, useTranslation as useTranslation26 } from "@wbk/config";
import { WithGrecaptcha as WithGrecaptcha3 } from "@wbk/api/grecaptcha";

// src/components/checkpoint/otp/VerifyEmail.tsx
import { useCallback, useEffect as useEffect8 } from "react";
import { Button as Button14, OtpInputs as OtpInputs2 } from "@wbk/ui";
import { useFormContext as useFormContext10 } from "react-hook-form";
import { useSendOtpToEmail, useVerifyEmail } from "@wbk/api/hooks";
import { ChevronIcon } from "@wbk/svg";
import { useAppSource as useAppSource3, useRouter as useRouter17, useTranslation as useTranslation22 } from "@wbk/config";
import { Fragment as Fragment5, jsx as jsx25, jsxs as jsxs24 } from "react/jsx-runtime";
var VerifyEmail = ({ show, profile, onSuccess }) => {
  const { user } = useAuth();
  const { appSource } = useAppSource3();
  const { locale } = useRouter17();
  const { t } = useTranslation22(["auth_common"]);
  const { setValue } = useFormContext10();
  const { mutateAsync: sendOtp, isPending: isSending, error: sendingError } = useSendOtpToEmail();
  const { mutateAsync: verifyOtp, isPending, error } = useVerifyEmail({ lang: locale });
  const handleSendOtp = useCallback(() => __async(void 0, null, function* () {
    try {
      if (show) {
        yield sendOtp({ locale, app_source: appSource });
      }
    } catch (err) {
    }
  }), [appSource, locale, show]);
  const handleVerify = (otp) => __async(void 0, null, function* () {
    try {
      yield verifyOtp({ code: otp, locale });
      const verifiedUser = __spreadProps(__spreadValues({}, user), {
        email_verified: true,
        force_verify_email: false
      });
      if (onSuccess) {
        onSuccess(verifiedUser, otp);
      }
    } catch (err) {
    }
  });
  useEffect8(() => {
    handleSendOtp();
  }, [handleSendOtp]);
  return /* @__PURE__ */ jsxs24("div", { children: [
    /* @__PURE__ */ jsx25("h2", { className: "pb-1 text-2xl font-semibold", children: t("auth_common:verify_your_email_address") }),
    /* @__PURE__ */ jsx25("p", { className: "text-text text-sm", children: t("auth_common:verify_your_email_address_desc", { email: (user == null ? void 0 : user.email) || "" }) }),
    /* @__PURE__ */ jsx25("div", { className: "pt-10", children: /* @__PURE__ */ jsx25(
      OtpInputs2,
      {
        formId: "checkout-vefity-otp",
        onChange: (otp) => {
          setValue("otp", otp);
        },
        onSubmit: (otp) => __async(void 0, null, function* () {
          setValue("otp", otp);
          handleVerify(otp);
        }),
        onlyNumbers: true,
        disabled: isPending,
        error: (error == null ? void 0 : error.message) || (sendingError == null ? void 0 : sendingError.message),
        renderButton: ({ resetState }) => /* @__PURE__ */ jsx25("div", { className: "mt-4 text-center text-sm", children: /* @__PURE__ */ jsx25(
          WithCountDown_default,
          {
            seconds: 60,
            render: ({ count, reset }) => /* @__PURE__ */ jsx25(
              Button14,
              {
                type: "button",
                shape: "text",
                theme: "action",
                className: "shrink-0 !bg-transparent px-2 py-1 text-sm underline",
                disabled: isSending || count > 0,
                loading: isPending,
                onClick: () => __async(void 0, null, function* () {
                  try {
                    yield handleSendOtp();
                    reset();
                    resetState();
                  } catch (error2) {
                  }
                }),
                id: "resend-otp",
                children: `${t("auth_common:resend_otp")} ${count > 0 ? `(${count})` : ""}`
              }
            )
          }
        ) })
      }
    ) }),
    /* @__PURE__ */ jsx25("hr", { className: "-mx-4 my-4 border-white/20" }),
    /* @__PURE__ */ jsxs24("div", { className: "flex items-center justify-between gap-4", children: [
      /* @__PURE__ */ jsx25("div", { className: "text-text text-sm", children: !(user == null ? void 0 : user.email_verified) && /* @__PURE__ */ jsx25(Fragment5, { children: profile ? /* @__PURE__ */ jsxs24(
        Button14,
        {
          className: "gap-2 px-2",
          theme: "action",
          shape: "text",
          type: "button",
          "data-testid": "auth_otp_change_email_button",
          onClick: () => {
            setValue("mode", "email-update");
          },
          children: [
            /* @__PURE__ */ jsx25(ChevronIcon, { className: "ltr:rotate-180" }),
            t("auth_common:change_email")
          ]
        }
      ) : /* @__PURE__ */ jsxs24(Fragment5, { children: [
        /* @__PURE__ */ jsx25("p", { children: t("auth_common:wrong_email") }),
        /* @__PURE__ */ jsx25(
          Button14,
          {
            className: "underline-offset-3 px-0 py-px underline !ring-0 hover:underline focus:underline",
            theme: "action",
            shape: "text",
            type: "button",
            "data-testid": "auth_otp_change_email_button",
            onClick: () => {
              setValue("mode", "email-update");
            },
            children: t("auth_common:change_email_address")
          }
        )
      ] }) }) }),
      /* @__PURE__ */ jsx25(
        Button14,
        {
          type: "submit",
          form: "checkout-vefity-otp",
          theme: "action",
          loading: isPending,
          className: "text-lg font-bold",
          children: t("auth_common:verify")
        }
      )
    ] })
  ] });
};
var VerifyEmail_default = VerifyEmail;

// src/components/checkpoint/otp/ChangeEmail.tsx
import { Controller as Controller7, useFormContext as useFormContext11 } from "react-hook-form";
import { Button as Button15, Input as Input6 } from "@wbk/ui";
import { useUpdateEmail } from "@wbk/api/hooks";
import { EMAIL_PATTERN as EMAIL_PATTERN2 } from "@wbk/utils";
import { useAppSource as useAppSource4, useRouter as useRouter18, useTranslation as useTranslation23 } from "@wbk/config";
import { jsx as jsx26, jsxs as jsxs25 } from "react/jsx-runtime";
var ChangeEmail = ({ onClose }) => {
  var _d, _e, _f;
  const { appSource } = useAppSource4();
  const { newsLetter } = useAuth();
  const { locale } = useRouter18();
  const { t } = useTranslation23(["auth_common"]);
  const {
    setValue,
    watch,
    control,
    formState: { errors },
    handleSubmit
  } = useFormContext11();
  const { mutateAsync, isPending, error } = useUpdateEmail({ lang: locale });
  const email = watch("email");
  const emailSuggestion = useEmailSpelling({ email });
  const onSubmit = (data) => __async(void 0, null, function* () {
    try {
      yield mutateAsync({ email: data.email, locale, app_source: appSource });
      setValue("mode", "otp");
    } catch (error2) {
    }
  });
  return /* @__PURE__ */ jsxs25("form", { onSubmit: handleSubmit(onSubmit), children: [
    /* @__PURE__ */ jsx26("h4", { className: "text-2xl font-semibold", children: t("auth_common:update_email") }),
    /* @__PURE__ */ jsx26("p", { className: "text-text-secondary pt-0.5 text-sm", children: t("auth_common:update_email_desc", { website: newsLetter.organizationName }) }),
    /* @__PURE__ */ jsxs25("fieldset", { className: "my-4 space-y-4 pb-4", children: [
      /* @__PURE__ */ jsxs25("div", { className: "relative", children: [
        /* @__PURE__ */ jsx26(
          Controller7,
          {
            control,
            name: "email",
            defaultValue: "",
            rules: {
              required: t("auth_common:validation.required"),
              pattern: {
                value: EMAIL_PATTERN2,
                message: t("auth_common:validation.invalid_email")
              }
            },
            render: (_a) => {
              var { field: _b } = _a, _c = _b, { onChange } = _c, props = __objRest(_c, ["onChange"]);
              var _a2, _b2, _c2;
              return /* @__PURE__ */ jsx26(
                Input6,
                __spreadProps(__spreadValues({
                  id: "new_email",
                  "data-testid": "auth_renew_email_input",
                  autoComplete: "off",
                  label: t("auth_common:new_email")
                }, props), {
                  onChange: (value) => {
                    onChange(value);
                  },
                  error: ((_a2 = errors.email) == null ? void 0 : _a2.message) || ((_c2 = (_b2 = error == null ? void 0 : error.errors) == null ? void 0 : _b2.email) == null ? void 0 : _c2[0]) || (error == null ? void 0 : error.message)
                })
              );
            }
          }
        ),
        emailSuggestion && /* @__PURE__ */ jsxs25(
          "div",
          {
            className: `text-text-tertiary absolute w-full rounded-lg bg-yellow-100 p-2 text-sm ${((_d = errors.email) == null ? void 0 : _d.message) || ((_f = (_e = error == null ? void 0 : error.errors) == null ? void 0 : _e.email) == null ? void 0 : _f[0]) ? "-bottom-4" : "-bottom-9"}`,
            children: [
              t("auth_common:validation.did_you_mean"),
              /* @__PURE__ */ jsx26(
                "button",
                {
                  onClick: () => setValue("email", emailSuggestion.full, {
                    shouldValidate: true
                  }),
                  className: "text-primary mx-1 cursor-pointer font-semibold hover:underline",
                  children: emailSuggestion.full
                }
              )
            ]
          }
        )
      ] }),
      /* @__PURE__ */ jsx26(
        Controller7,
        {
          control,
          name: "confirm_email",
          rules: {
            required: t("auth_common:validation.required"),
            validate: (value) => value === email || t("auth_common:validation.emails_not_match")
          },
          defaultValue: "",
          render: (_g) => {
            var { field: _h } = _g, _i = _h, { onChange } = _i, props = __objRest(_i, ["onChange"]);
            var _a;
            return /* @__PURE__ */ jsx26(
              Input6,
              __spreadProps(__spreadValues({}, props), {
                id: "confirm_email",
                "data-testid": "auth_confirm_email_input",
                autoComplete: "off",
                label: t("auth_common:confirm_email"),
                onChange: (value) => {
                  onChange(value);
                },
                onPaste: (e) => {
                  e.preventDefault();
                },
                error: (_a = errors.confirm_email) == null ? void 0 : _a.message
              })
            );
          }
        }
      )
    ] }),
    /* @__PURE__ */ jsx26("hr", { className: "-mx-4 my-4 border-white/20" }),
    /* @__PURE__ */ jsxs25("div", { className: "flex items-center justify-end gap-4", children: [
      /* @__PURE__ */ jsx26(
        Button15,
        {
          theme: "action",
          shape: "text",
          type: "button",
          "data-testid": "auth_update_email_cancel_button",
          onClick: onClose,
          children: t("auth_common:cancel")
        }
      ),
      /* @__PURE__ */ jsx26(
        Button15,
        {
          type: "submit",
          theme: "action",
          loading: isPending,
          className: "text-lg font-bold",
          "data-testid": "auth_update_email_confirm_button",
          children: t("auth_common:update_email")
        }
      )
    ] })
  ] });
};
var ChangeEmail_default = ChangeEmail;

// src/components/checkpoint/otp/Entry.tsx
import { Button as Button16, Typography as Typography5 } from "@wbk/ui";
import { useFormContext as useFormContext12 } from "react-hook-form";
import { useTranslation as useTranslation24 } from "@wbk/config";
import { jsx as jsx27, jsxs as jsxs26 } from "react/jsx-runtime";
var Entry2 = ({ description, onClose }) => {
  const { user } = useAuth({ autoFetch: true });
  const { setValue } = useFormContext12();
  const { t } = useTranslation24(["auth_common"]);
  return /* @__PURE__ */ jsxs26("div", { children: [
    /* @__PURE__ */ jsxs26("div", { className: "space-y-6", children: [
      /* @__PURE__ */ jsx27(Typography5, { variant: "heading-XL", children: t("auth_common:verify_your_email_address") }),
      /* @__PURE__ */ jsx27(Typography5, { className: "text-text-secondary", children: description || t("auth_common:email_verification_description") }),
      (user == null ? void 0 : user.email) && /* @__PURE__ */ jsx27(Typography5, { variant: "body-L", children: user == null ? void 0 : user.email }),
      /* @__PURE__ */ jsx27(
        Button16,
        {
          shape: "text",
          theme: "action",
          className: "p-0 underline",
          onClick: () => setValue("mode", "email-update"),
          children: t("auth_common:change_email")
        }
      )
    ] }),
    /* @__PURE__ */ jsx27("hr", { className: "-mx-4 my-4 border-white/20" }),
    /* @__PURE__ */ jsxs26("div", { className: "flex items-center justify-end gap-4", children: [
      onClose && /* @__PURE__ */ jsx27(
        Button16,
        {
          theme: "action",
          shape: "text",
          type: "button",
          "data-testid": "auth_update_email_cancel_button",
          onClick: onClose,
          children: t("auth_common:cancel")
        }
      ),
      /* @__PURE__ */ jsx27(
        Button16,
        {
          theme: "action",
          className: "text-lg font-bold",
          "data-testid": "auth_update_email_confirm_button",
          onClick: () => setValue("mode", "otp"),
          children: t("auth_common:send_otp")
        }
      )
    ] })
  ] });
};
var Entry_default2 = Entry2;

// src/components/checkpoint/otp/EnterOtp.tsx
import { useCallback as useCallback2, useEffect as useEffect9 } from "react";
import { Button as Button17, OtpInputs as OtpInputs3 } from "@wbk/ui";
import { useFormContext as useFormContext13 } from "react-hook-form";
import { useRouter as useRouter19, useTranslation as useTranslation25 } from "@wbk/config";
import { useSendOtp } from "@wbk/api/hooks";
import { jsx as jsx28, jsxs as jsxs27 } from "react/jsx-runtime";
var VerifyEmail2 = ({ show, onSuccess }) => {
  const { user } = useAuth();
  const { locale } = useRouter19();
  const { t } = useTranslation25(["auth_common"]);
  const { setValue } = useFormContext13();
  const { mutateAsync: sendOtp, isPending: isSending, error: sendingError } = useSendOtp();
  const handleSendOtp = useCallback2(() => __async(void 0, null, function* () {
    try {
      if (show) {
        yield sendOtp({ lang: locale, source: "wallet-debit" });
      }
    } catch (err) {
    }
  }), [locale, show]);
  const handleSubmit = (otp) => __async(void 0, null, function* () {
    onSuccess == null ? void 0 : onSuccess(user, otp);
  });
  useEffect9(() => {
    handleSendOtp();
  }, [handleSendOtp]);
  return /* @__PURE__ */ jsxs27("div", { children: [
    /* @__PURE__ */ jsx28("h2", { className: "pb-1 text-2xl font-semibold", children: t("auth_common:verify_your_email_address") }),
    /* @__PURE__ */ jsx28("p", { className: "text-text text-sm", children: t("auth_common:verify_your_email_address_desc", { email: (user == null ? void 0 : user.email) || "" }) }),
    /* @__PURE__ */ jsx28("div", { className: "pt-10", children: /* @__PURE__ */ jsx28(
      OtpInputs3,
      {
        formId: "checkout-vefity-otp",
        onChange: (otp) => {
          setValue("otp", otp);
        },
        onSubmit: (otp) => __async(void 0, null, function* () {
          setValue("otp", otp);
          handleSubmit(otp);
        }),
        onlyNumbers: true,
        error: sendingError == null ? void 0 : sendingError.message,
        renderButton: ({ resetState }) => /* @__PURE__ */ jsx28("div", { className: "mt-4 text-center text-sm", children: /* @__PURE__ */ jsx28(
          WithCountDown_default,
          {
            seconds: 60,
            render: ({ count, reset }) => /* @__PURE__ */ jsx28(
              Button17,
              {
                type: "button",
                shape: "text",
                theme: "action",
                className: "shrink-0 !bg-transparent px-2 py-1 text-sm underline",
                disabled: isSending || count > 0,
                onClick: () => __async(void 0, null, function* () {
                  try {
                    yield handleSendOtp();
                    reset();
                    resetState();
                  } catch (error) {
                  }
                }),
                id: "resend-otp",
                children: `${t("auth_common:resend_otp")} ${count > 0 ? `(${count})` : ""}`
              }
            )
          }
        ) })
      }
    ) }),
    /* @__PURE__ */ jsx28("hr", { className: "-mx-4 my-4 border-white/20" }),
    /* @__PURE__ */ jsx28("div", { className: "flex items-center justify-end gap-4", children: /* @__PURE__ */ jsx28(
      Button17,
      {
        type: "submit",
        form: "checkout-vefity-otp",
        theme: "action",
        className: "text-lg font-bold",
        children: t("auth_common:verify")
      }
    ) })
  ] });
};
var EnterOtp_default = VerifyEmail2;

// src/components/checkpoint/otp/index.tsx
import { jsx as jsx29, jsxs as jsxs28 } from "react/jsx-runtime";
var OtpCheckPoint = ({
  show,
  render,
  onSuccess,
  onClose,
  flatLayout,
  className,
  initialMode = "entry",
  profile,
  description,
  type = "verify_email"
}) => {
  const { isMobile } = useDeviceDetect3();
  const { locale } = useRouter20();
  const { t } = useTranslation26(["auth_common"]);
  const methods = useForm5({
    defaultValues: { mode: initialMode }
  });
  const mode = methods.watch("mode");
  const toast = useRef4(void 0);
  const handleClose = () => {
    if (onClose) {
      onClose();
    }
    setTimeout(methods.reset, 200);
  };
  const handleSuccess = (result, otp) => {
    var _a;
    if (onSuccess) {
      onSuccess(result, otp);
    }
    if (type === "verify_email") {
      (_a = toast.current) == null ? void 0 : _a.publish({
        title: t("auth_common:email_verified_successfully"),
        icon: true
      });
    }
  };
  const Body = /* @__PURE__ */ jsx29(FormProvider4, __spreadProps(__spreadValues({}, methods), { children: /* @__PURE__ */ jsx29("div", { className: "overflow-hidden", children: /* @__PURE__ */ jsx29(AnimatePresence6, { initial: false, mode: "wait", children: /* @__PURE__ */ jsx29(
    motion6.div,
    {
      className: twMerge4("p-4", className),
      initial: { x: (locale == null ? void 0 : locale.startsWith("ar")) ? "100%" : "-100%", opacity: 0 },
      animate: { x: 0, opacity: 1 },
      exit: { x: (locale == null ? void 0 : locale.startsWith("ar")) ? "-100%" : "100%", opacity: 0 },
      transition: { duration: 0.2 },
      children: mode === "entry" ? /* @__PURE__ */ jsx29(Entry_default2, { description, onClose: flatLayout ? void 0 : handleClose }) : mode === "email-update" ? /* @__PURE__ */ jsx29(ChangeEmail_default, { onClose: handleClose }) : type === "verify_wallet" ? /* @__PURE__ */ jsx29(EnterOtp_default, { show, onSuccess: handleSuccess }) : /* @__PURE__ */ jsx29(VerifyEmail_default, { show, onSuccess: handleSuccess, profile })
    },
    `${mode}-${locale}`
  ) }) }) }));
  if (flatLayout) {
    return Body;
  }
  return /* @__PURE__ */ jsxs28(WithGrecaptcha3, { children: [
    isMobile ? /* @__PURE__ */ jsx29(
      BottomSheet2,
      {
        ignoreHistory: true,
        show,
        onClose: handleClose,
        className: "z-[999]",
        sectionClassName: "pb-12",
        render,
        body: () => Body
      }
    ) : /* @__PURE__ */ jsx29(
      Modal3,
      {
        closeButton: true,
        ignoreHistory: true,
        show,
        onClose: handleClose,
        render,
        body: () => Body,
        zIndex: 999
      }
    ),
    /* @__PURE__ */ jsx29(Toast2, { ref: toast })
  ] });
};

// src/components/checkpoint/profile/index.tsx
import { useEffect as useEffect10 } from "react";
import { Controller as Controller8, FormProvider as FormProvider5, useForm as useForm6 } from "react-hook-form";
import { twMerge as twMerge5 } from "tailwind-merge";
import { BottomSheet as BottomSheet3, Button as Button18, Input as Input7, Modal as Modal4, ToggleGroup as ToggleGroup2 } from "@wbk/ui";
import { useDeviceDetect as useDeviceDetect4 } from "@wbk/hooks";
import { useUpdateProfile as useUpdateProfile4 } from "@wbk/api/hooks";
import { AnimatePresence as AnimatePresence7, motion as motion7 } from "motion/react";
import { useGeolocation as useGeolocation4, useRouter as useRouter21, useTranslation as useTranslation27 } from "@wbk/config";
import { COUNTRIES as COUNTRIES5 } from "@wbk/utils";
import { Fragment as Fragment6, jsx as jsx30, jsxs as jsxs29 } from "react/jsx-runtime";
var ProfileCheckPoint = ({
  show,
  onSuccess,
  onClose,
  flatLayout,
  className,
  showVisaCheckbox
}) => {
  var _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
  const { isMobile } = useDeviceDetect4();
  const { user } = useAuth();
  const { locale } = useRouter21();
  const { t } = useTranslation27(["auth_common"]);
  const { mutateAsync: updateProfile, isPending, error } = useUpdateProfile4({ lang: locale });
  const methods = useForm6();
  const { country: detectedCountry } = useGeolocation4();
  useEffect10(() => {
    var _a;
    const dialCountry = COUNTRIES5.find((c) => c.code === (user == null ? void 0 : user.cell_country_code)) || detectedCountry;
    const phone = (_a = user == null ? void 0 : user.cell_number) == null ? void 0 : _a.replace(`+${dialCountry == null ? void 0 : dialCountry.dial_code}`, "");
    methods.reset(__spreadProps(__spreadValues({}, getDefaultUser(user)), { dialCountry, phone }));
  }, [detectedCountry == null ? void 0 : detectedCountry.code, user == null ? void 0 : user.cell_country_code, user == null ? void 0 : user.cell_number]);
  const needVisa = methods.watch("require_visa");
  const onSubmit = (_a) => __async(void 0, null, function* () {
    var _b = _a, { dialCountry, phone } = _b, data = __objRest(_b, ["dialCountry", "phone"]);
    var _a2;
    try {
      const body = __spreadProps(__spreadValues({}, data), {
        cell_country_code: dialCountry == null ? void 0 : dialCountry.code,
        cell_number: phone,
        dob: (_a2 = data.dob) == null ? void 0 : _a2.split("-").reverse().join("/"),
        passport_data: data.require_visa === "yes" && data.passport_data ? __spreadProps(__spreadValues({}, data.passport_data), {
          nationality: data.nationality || ""
        }) : void 0
      });
      const newUser = yield updateProfile({ user: body, locale });
      if (onSuccess) {
        onSuccess(newUser);
      }
    } catch (err) {
    }
  });
  const Body = /* @__PURE__ */ jsx30(FormProvider5, __spreadProps(__spreadValues({}, methods), { children: /* @__PURE__ */ jsxs29(
    "form",
    {
      id: "checkout-complete-profile",
      onSubmit: methods.handleSubmit(onSubmit),
      className: twMerge5("space-y-4 px-4", className),
      children: [
        /* @__PURE__ */ jsxs29("div", { children: [
          /* @__PURE__ */ jsx30("h2", { className: "pb-1 text-2xl font-semibold", children: t("auth_common:complete_your_account") }),
          /* @__PURE__ */ jsx30("p", { className: "text-sm", children: t("auth_common:complete_your_account_desc") })
        ] }),
        /* @__PURE__ */ jsx30(FormItems_default, { error }),
        showVisaCheckbox && /* @__PURE__ */ jsxs29(Fragment6, { children: [
          /* @__PURE__ */ jsx30(
            Controller8,
            {
              name: "require_visa",
              control: methods.control,
              rules: { required: t("auth_common:validation.required") },
              render: ({ field }) => {
                var _a;
                return /* @__PURE__ */ jsx30(
                  ToggleGroup2,
                  __spreadProps(__spreadValues({
                    label: t("auth_common:require_visa"),
                    type: "single",
                    options: [
                      { text: t("auth_common:yes"), value: "yes" },
                      { text: t("auth_common:no"), value: "no" }
                    ]
                  }, field), {
                    error: (_a = methods.formState.errors.require_visa) == null ? void 0 : _a.message
                  })
                );
              }
            }
          ),
          /* @__PURE__ */ jsx30(AnimatePresence7, { initial: false, children: needVisa === "yes" && /* @__PURE__ */ jsxs29(
            motion7.div,
            {
              className: "space-y-4 overflow-hidden",
              initial: { height: 0 },
              animate: { height: "auto" },
              exit: { height: 0 },
              children: [
                /* @__PURE__ */ jsx30(
                  Input7,
                  __spreadProps(__spreadValues({
                    id: "passport",
                    label: t("auth_common:passport"),
                    placeholder: t("auth_common:passport")
                  }, methods.register("passport_data.passport", {
                    required: t("auth_common:validation.required"),
                    minLength: {
                      value: 7,
                      message: t("auth_common:validation.min_length", { min: 7 })
                    },
                    maxLength: {
                      value: 25,
                      message: t("auth_common:validation.max_length", { max: 25 })
                    }
                  })), {
                    onChange: (value) => {
                      methods.setValue("passport_data.passport", value);
                    },
                    error: ((_d = (_c = methods.formState.errors.passport_data) == null ? void 0 : _c.passport) == null ? void 0 : _d.message) || ((_f = (_e = error == null ? void 0 : error.errors) == null ? void 0 : _e.passport) == null ? void 0 : _f[0])
                  })
                ),
                /* @__PURE__ */ jsxs29("div", { className: "flex flex-col gap-4 py-1 sm:flex-row", children: [
                  /* @__PURE__ */ jsx30(
                    Input7,
                    __spreadProps(__spreadValues({
                      type: "date",
                      groupClassName: "grow",
                      pattern: "\\d{4}-\\d{2}-\\d{2}",
                      max: (/* @__PURE__ */ new Date()).toISOString().split("T")[0],
                      label: t("auth_common:issue_date")
                    }, methods.register("passport_data.issue_date", {
                      required: t("auth_common:validation.required")
                    })), {
                      onChange: (value) => {
                        methods.setValue("passport_data.issue_date", value);
                      },
                      error: ((_h = (_g = methods.formState.errors.passport_data) == null ? void 0 : _g.issue_date) == null ? void 0 : _h.message) || ((_j = (_i = error == null ? void 0 : error.errors) == null ? void 0 : _i.issue_date) == null ? void 0 : _j[0])
                    })
                  ),
                  /* @__PURE__ */ jsx30(
                    Input7,
                    __spreadProps(__spreadValues({
                      type: "date",
                      groupClassName: "grow",
                      min: (/* @__PURE__ */ new Date()).toISOString().split("T")[0],
                      pattern: "\\d{4}-\\d{2}-\\d{2}",
                      label: t("auth_common:expiry_date")
                    }, methods.register("passport_data.expiry_date", {
                      required: t("auth_common:validation.required")
                    })), {
                      onChange: (value) => {
                        methods.setValue("passport_data.expiry_date", value);
                      },
                      error: ((_l = (_k = methods.formState.errors.passport_data) == null ? void 0 : _k.expiry_date) == null ? void 0 : _l.message) || ((_n = (_m = error == null ? void 0 : error.errors) == null ? void 0 : _m.expiry_date) == null ? void 0 : _n[0])
                    })
                  )
                ] })
              ]
            }
          ) })
        ] })
      ]
    }
  ) }));
  if (flatLayout) {
    return Body;
  }
  return isMobile ? /* @__PURE__ */ jsx30(
    BottomSheet3,
    {
      fullscreen: true,
      show,
      onClose,
      stickyHeader: ({ close }) => /* @__PURE__ */ jsx30(Header, { onClose: close }),
      stickyFooter: () => /* @__PURE__ */ jsx30(Footer, { isPending }),
      body: () => Body,
      className: "z-[999] pb-28"
    }
  ) : /* @__PURE__ */ jsx30(
    Modal4,
    {
      className: "overflow-y-auto pb-24",
      zIndex: 999,
      show,
      onClose,
      stickyHeader: ({ close }) => /* @__PURE__ */ jsx30(Header, { onClose: close }),
      stickyFooter: () => /* @__PURE__ */ jsx30(Footer, { isPending }),
      body: () => Body
    }
  );
};
var Header = ({ onClose }) => {
  const { t } = useTranslation27(["auth_common"]);
  return /* @__PURE__ */ jsx30("div", { className: "flex w-full items-center justify-between rounded-t-md p-2 pb-1", children: /* @__PURE__ */ jsx30(
    Back_default,
    {
      tabIndex: -1,
      className: "mb-0",
      text: t("auth_common:change_tickets"),
      onClick: onClose
    }
  ) });
};
var Footer = ({ isPending }) => {
  const { t } = useTranslation27(["auth_common"]);
  return /* @__PURE__ */ jsx30("div", { className: "p-4", children: /* @__PURE__ */ jsx30(Button18, { className: "w-full", type: "submit", form: "checkout-complete-profile", loading: isPending, children: /* @__PURE__ */ jsx30("span", { className: "text-xl font-bold", children: t("auth_common:confirm") }) }) });
};

export {
  ForceUpdateProfileCheckPoint,
  NafathCheckPoint,
  OtpCheckPoint,
  ProfileCheckPoint,
  AuthForm,
  LogoutModal_default,
  AuthModal_default,
  ProfileMenu,
  UserProfile,
  ProfileTop,
  WithAuth,
  AuthProvider
};
//# sourceMappingURL=chunk-ABG5P2PW.mjs.map